/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as WelcomeRouteImport } from "./routes/welcome"
import { Route as TermsOfUseRouteImport } from "./routes/terms-of-use"
import { Route as PrivacyPolicyRouteImport } from "./routes/privacy-policy"
import { Route as PoliciesRouteImport } from "./routes/policies"
import { Route as HelpRouteImport } from "./routes/help"
import { Route as ConfirmationRouteImport } from "./routes/confirmation"
import { Route as AuthRouteRouteImport } from "./routes/auth/route"
import { Route as AuthenticatedRouteRouteImport } from "./routes/_authenticated/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as ReceiptIndexRouteImport } from "./routes/receipt/index"
import { Route as AuthIndexRouteImport } from "./routes/auth/index"
import { Route as ReceiptReceiptIDRouteImport } from "./routes/receipt/$receiptID"
import { Route as AuthVerifyRouteImport } from "./routes/auth/verify"
import { Route as AuthResetPasswordRouteImport } from "./routes/auth/reset-password"
import { Route as AuthForgotPasswordRouteImport } from "./routes/auth/forgot-password"
import { Route as AuthCreateAccountRouteImport } from "./routes/auth/create-account"
import { Route as QrQrLookupIDRouteRouteImport } from "./routes/qr/$qrLookupID/route"
import { Route as AuthenticatedAccountRouteRouteImport } from "./routes/_authenticated/account/route"
import { Route as QrQrLookupIDIndexRouteImport } from "./routes/qr/$qrLookupID/index"
import { Route as AuthSignInIndexRouteImport } from "./routes/auth/sign-in/index"
import { Route as AuthenticatedAccountIndexRouteImport } from "./routes/_authenticated/account/index"
import { Route as QrQrLookupIDTermsOfUseRouteImport } from "./routes/qr/$qrLookupID/terms-of-use"
import { Route as QrQrLookupIDPrivacyPolicyRouteImport } from "./routes/qr/$qrLookupID/privacy-policy"
import { Route as QrQrLookupIDPoliciesRouteImport } from "./routes/qr/$qrLookupID/policies"
import { Route as QrQrLookupIDHelpRouteImport } from "./routes/qr/$qrLookupID/help"
import { Route as AuthSignInSetNewPasswordRouteImport } from "./routes/auth/sign-in/set-new-password"
import { Route as AuthenticatedAccountUpdatePasswordRouteImport } from "./routes/_authenticated/account/update-password"
import { Route as AuthenticatedAccountReservationsRouteImport } from "./routes/_authenticated/account/reservations"
import { Route as AuthenticatedAccountPersonalInformationRouteImport } from "./routes/_authenticated/account/personal-information"
import { Route as QrQrLookupIDDevRouteRouteImport } from "./routes/qr/$qrLookupID/dev/route"
import { Route as QrQrLookupIDAuthenticatedRouteRouteImport } from "./routes/qr/$qrLookupID/_authenticated/route"
import { Route as AuthenticatedAccountVehiclesRouteRouteImport } from "./routes/_authenticated/account/vehicles/route"
import { Route as AuthenticatedAccountSavedPaymentMethodsRouteRouteImport } from "./routes/_authenticated/account/saved-payment-methods/route"
import { Route as AuthenticatedAccountPassesRouteRouteImport } from "./routes/_authenticated/account/passes/route"
import { Route as QrQrLookupIDWelcomeIndexRouteImport } from "./routes/qr/$qrLookupID/welcome/index"
import { Route as QrQrLookupIDDevIndexRouteImport } from "./routes/qr/$qrLookupID/dev/index"
import { Route as AuthenticatedAccountVehiclesIndexRouteImport } from "./routes/_authenticated/account/vehicles/index"
import { Route as AuthenticatedAccountSavedPaymentMethodsIndexRouteImport } from "./routes/_authenticated/account/saved-payment-methods/index"
import { Route as AuthenticatedAccountPassesIndexRouteImport } from "./routes/_authenticated/account/passes/index"
import { Route as AuthenticatedAccountMembershipsIndexRouteImport } from "./routes/_authenticated/account/memberships/index"
import { Route as QrQrLookupIDReceiptReceiptIDRouteImport } from "./routes/qr/$qrLookupID/receipt/$receiptID"
import { Route as QrQrLookupIDDevGutCheckRouteImport } from "./routes/qr/$qrLookupID/dev/gut-check"
import { Route as AuthenticatedAccountVehiclesEditRouteImport } from "./routes/_authenticated/account/vehicles/edit"
import { Route as AuthenticatedAccountVehiclesCreateRouteImport } from "./routes/_authenticated/account/vehicles/create"
import { Route as AuthenticatedAccountSavedPaymentMethodsAddRouteImport } from "./routes/_authenticated/account/saved-payment-methods/add"
import { Route as AuthenticatedAccountPassesPassIDRouteImport } from "./routes/_authenticated/account/passes/$passID"
import { Route as QrQrLookupIDReserveEpochRouteRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/route"
import { Route as QrQrLookupIDPassesEpochRouteRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/route"
import { Route as QrQrLookupIDParkEpochRouteRouteImport } from "./routes/qr/$qrLookupID/park/$epoch/route"
import { Route as QrQrLookupIDGatedPamIDRouteRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/route"
import { Route as QrQrLookupIDAuthenticatedAccountRouteRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/route"
import { Route as QrQrLookupIDGatedPamIDIndexRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/index"
import { Route as QrQrLookupIDAuthenticatedAccountIndexRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/index"
import { Route as QrQrLookupIDReserveEpochPaymentCompleteRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/payment-complete"
import { Route as QrQrLookupIDParkEpochRegisterRouteImport } from "./routes/qr/$qrLookupID/park/$epoch/register"
import { Route as QrQrLookupIDParkEpochRatesRouteImport } from "./routes/qr/$qrLookupID/park/$epoch/rates"
import { Route as QrQrLookupIDParkEpochPaymentCompleteRouteImport } from "./routes/qr/$qrLookupID/park/$epoch/payment-complete"
import { Route as QrQrLookupIDParkEpochConfirmationRouteImport } from "./routes/qr/$qrLookupID/park/$epoch/confirmation"
import { Route as QrQrLookupIDParkEpochCheckoutRouteImport } from "./routes/qr/$qrLookupID/park/$epoch/checkout"
import { Route as QrQrLookupIDParkEpochCartRouteImport } from "./routes/qr/$qrLookupID/park/$epoch/cart"
import { Route as QrQrLookupIDGatedRegisterLookUpRouteImport } from "./routes/qr/$qrLookupID/gated/register/look-up"
import { Route as QrQrLookupIDGatedRegisterContactInfoRouteImport } from "./routes/qr/$qrLookupID/gated/register/contact-info"
import { Route as QrQrLookupIDDevOrganismsReservationRateCardRouteImport } from "./routes/qr/$qrLookupID/dev/organisms/reservation-rate-card"
import { Route as QrQrLookupIDDevOrganismsNavigationRouteImport } from "./routes/qr/$qrLookupID/dev/organisms/navigation"
import { Route as QrQrLookupIDDevMoleculesRangeCalendarRouteImport } from "./routes/qr/$qrLookupID/dev/molecules/range-calendar"
import { Route as QrQrLookupIDDevMoleculesModalRouteImport } from "./routes/qr/$qrLookupID/dev/molecules/modal"
import { Route as QrQrLookupIDDevMoleculesFormsRouteImport } from "./routes/qr/$qrLookupID/dev/molecules/forms"
import { Route as QrQrLookupIDDevMoleculesDateDisplayRouteImport } from "./routes/qr/$qrLookupID/dev/molecules/date-display"
import { Route as QrQrLookupIDDevAtomsTypographyRouteImport } from "./routes/qr/$qrLookupID/dev/atoms/typography"
import { Route as QrQrLookupIDDevAtomsIconRouteImport } from "./routes/qr/$qrLookupID/dev/atoms/icon"
import { Route as QrQrLookupIDDevAtomsCardRouteImport } from "./routes/qr/$qrLookupID/dev/atoms/card"
import { Route as QrQrLookupIDDevAtomsButtonRouteImport } from "./routes/qr/$qrLookupID/dev/atoms/button"
import { Route as QrQrLookupIDAuthenticatedAccountUpdatePasswordRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/update-password"
import { Route as QrQrLookupIDAuthenticatedAccountReservationsRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/reservations"
import { Route as QrQrLookupIDAuthenticatedAccountPersonalInformationRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/personal-information"
import { Route as QrQrLookupIDPassesEpochPurchaseRouteRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/purchase/route"
import { Route as QrQrLookupIDGatedRegisterSessionIDRouteRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/route"
import { Route as QrQrLookupIDGatedPamIDSessionIDRouteRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/route"
import { Route as QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/vehicles/route"
import { Route as QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/saved-payment-methods/route"
import { Route as QrQrLookupIDAuthenticatedAccountPassesRouteRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/passes/route"
import { Route as QrQrLookupIDReserveEpochCalendarsIndexRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/index"
import { Route as QrQrLookupIDPassesEpochPurchaseIndexRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/purchase/index"
import { Route as QrQrLookupIDGatedPamIDLookUpIndexRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/look-up.index"
import { Route as QrQrLookupIDGatedPamIDSessionIDIndexRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/index"
import { Route as QrQrLookupIDAuthenticatedAccountVehiclesIndexRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/vehicles/index"
import { Route as QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/saved-payment-methods/index"
import { Route as QrQrLookupIDAuthenticatedAccountPassesIndexRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/passes/index"
import { Route as QrQrLookupIDAuthenticatedAccountMembershipsIndexRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/memberships/index"
import { Route as QrQrLookupIDPassesEpochPurchasePaymentCompleteRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/purchase/payment-complete"
import { Route as QrQrLookupIDPassesEpochPurchaseConfirmationRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/purchase/confirmation"
import { Route as QrQrLookupIDPassesEpochPurchaseCheckoutRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/purchase/checkout"
import { Route as QrQrLookupIDPassesEpochPurchaseCartRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/purchase/cart"
import { Route as QrQrLookupIDGatedRegisterSessionIDPaymentStatusRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/payment-status"
import { Route as QrQrLookupIDGatedRegisterSessionIDExpressRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/express"
import { Route as QrQrLookupIDGatedRegisterSessionIDConfirmationRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/confirmation"
import { Route as QrQrLookupIDGatedRegisterSessionIDCompleteRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/complete"
import { Route as QrQrLookupIDGatedRegisterSessionIDCheckoutRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/checkout"
import { Route as QrQrLookupIDGatedRegisterSessionIDCartRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/cart"
import { Route as QrQrLookupIDGatedPamIDLookUpChallengeRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/look-up.challenge"
import { Route as QrQrLookupIDGatedPamIDSessionIDPaymentStatusRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
import { Route as QrQrLookupIDGatedPamIDSessionIDCheckoutRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
import { Route as QrQrLookupIDGatedPamIDSessionIDCartRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
import { Route as QrQrLookupIDAuthenticatedAccountVehiclesEditRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/vehicles/edit"
import { Route as QrQrLookupIDAuthenticatedAccountVehiclesCreateRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/vehicles/create"
import { Route as QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/saved-payment-methods/add"
import { Route as QrQrLookupIDAuthenticatedAccountPassesPassIDRouteImport } from "./routes/qr/$qrLookupID/_authenticated/account/passes/$passID"
import { Route as QrQrLookupIDPassesEpochRedeemPassIDRouteRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/redeem.$passID/route"
import { Route as QrQrLookupIDPassesEpochRedeemPassIDIndexRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/redeem.$passID/index"
import { Route as QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/redeem.$passID/redemption-complete"
import { Route as QrQrLookupIDPassesEpochRedeemPassIDConfirmationRouteImport } from "./routes/qr/$qrLookupID/passes.$epoch/redeem.$passID/confirmation"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month/index"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month.$day/vehicles"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month.$day/confirmation"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month.$day/checkout"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month.$day/rates/index"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month.$day/cart/index"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month.$day/cart/in-progress"
import { Route as QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRouteImport } from "./routes/qr/$qrLookupID/reserve.$epoch/calendars/$calendarID/dates/$year.$month.$day/cart/expired"

const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfUseRoute = TermsOfUseRouteImport.update({
  id: "/terms-of-use",
  path: "/terms-of-use",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: "/privacy-policy",
  path: "/privacy-policy",
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesRoute = PoliciesRouteImport.update({
  id: "/policies",
  path: "/policies",
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: "/help",
  path: "/help",
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmationRoute = ConfirmationRouteImport.update({
  id: "/confirmation",
  path: "/confirmation",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: "/auth",
  path: "/auth",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ReceiptIndexRoute = ReceiptIndexRouteImport.update({
  id: "/receipt/",
  path: "/receipt/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthRouteRoute,
} as any)
const ReceiptReceiptIDRoute = ReceiptReceiptIDRouteImport.update({
  id: "/receipt/$receiptID",
  path: "/receipt/$receiptID",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: "/verify",
  path: "/verify",
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCreateAccountRoute = AuthCreateAccountRouteImport.update({
  id: "/create-account",
  path: "/create-account",
  getParentRoute: () => AuthRouteRoute,
} as any)
const QrQrLookupIDRouteRoute = QrQrLookupIDRouteRouteImport.update({
  id: "/qr/$qrLookupID",
  path: "/qr/$qrLookupID",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountRouteRoute =
  AuthenticatedAccountRouteRouteImport.update({
    id: "/account",
    path: "/account",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const QrQrLookupIDIndexRoute = QrQrLookupIDIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)
const AuthSignInIndexRoute = AuthSignInIndexRouteImport.update({
  id: "/sign-in/",
  path: "/sign-in/",
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDTermsOfUseRoute = QrQrLookupIDTermsOfUseRouteImport.update({
  id: "/terms-of-use",
  path: "/terms-of-use",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)
const QrQrLookupIDPrivacyPolicyRoute =
  QrQrLookupIDPrivacyPolicyRouteImport.update({
    id: "/privacy-policy",
    path: "/privacy-policy",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDPoliciesRoute = QrQrLookupIDPoliciesRouteImport.update({
  id: "/policies",
  path: "/policies",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)
const QrQrLookupIDHelpRoute = QrQrLookupIDHelpRouteImport.update({
  id: "/help",
  path: "/help",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)
const AuthSignInSetNewPasswordRoute =
  AuthSignInSetNewPasswordRouteImport.update({
    id: "/sign-in/set-new-password",
    path: "/sign-in/set-new-password",
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthenticatedAccountUpdatePasswordRoute =
  AuthenticatedAccountUpdatePasswordRouteImport.update({
    id: "/update-password",
    path: "/update-password",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountReservationsRoute =
  AuthenticatedAccountReservationsRouteImport.update({
    id: "/reservations",
    path: "/reservations",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountPersonalInformationRoute =
  AuthenticatedAccountPersonalInformationRouteImport.update({
    id: "/personal-information",
    path: "/personal-information",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDDevRouteRoute = QrQrLookupIDDevRouteRouteImport.update({
  id: "/dev",
  path: "/dev",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)
const QrQrLookupIDAuthenticatedRouteRoute =
  QrQrLookupIDAuthenticatedRouteRouteImport.update({
    id: "/_authenticated",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const AuthenticatedAccountVehiclesRouteRoute =
  AuthenticatedAccountVehiclesRouteRouteImport.update({
    id: "/vehicles",
    path: "/vehicles",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountSavedPaymentMethodsRouteRoute =
  AuthenticatedAccountSavedPaymentMethodsRouteRouteImport.update({
    id: "/saved-payment-methods",
    path: "/saved-payment-methods",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountPassesRouteRoute =
  AuthenticatedAccountPassesRouteRouteImport.update({
    id: "/passes",
    path: "/passes",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDWelcomeIndexRoute =
  QrQrLookupIDWelcomeIndexRouteImport.update({
    id: "/welcome/",
    path: "/welcome/",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDDevIndexRoute = QrQrLookupIDDevIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => QrQrLookupIDDevRouteRoute,
} as any)
const AuthenticatedAccountVehiclesIndexRoute =
  AuthenticatedAccountVehiclesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountVehiclesRouteRoute,
  } as any)
const AuthenticatedAccountSavedPaymentMethodsIndexRoute =
  AuthenticatedAccountSavedPaymentMethodsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountSavedPaymentMethodsRouteRoute,
  } as any)
const AuthenticatedAccountPassesIndexRoute =
  AuthenticatedAccountPassesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountPassesRouteRoute,
  } as any)
const AuthenticatedAccountMembershipsIndexRoute =
  AuthenticatedAccountMembershipsIndexRouteImport.update({
    id: "/memberships/",
    path: "/memberships/",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDReceiptReceiptIDRoute =
  QrQrLookupIDReceiptReceiptIDRouteImport.update({
    id: "/receipt/$receiptID",
    path: "/receipt/$receiptID",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDDevGutCheckRoute = QrQrLookupIDDevGutCheckRouteImport.update({
  id: "/gut-check",
  path: "/gut-check",
  getParentRoute: () => QrQrLookupIDDevRouteRoute,
} as any)
const AuthenticatedAccountVehiclesEditRoute =
  AuthenticatedAccountVehiclesEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthenticatedAccountVehiclesRouteRoute,
  } as any)
const AuthenticatedAccountVehiclesCreateRoute =
  AuthenticatedAccountVehiclesCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => AuthenticatedAccountVehiclesRouteRoute,
  } as any)
const AuthenticatedAccountSavedPaymentMethodsAddRoute =
  AuthenticatedAccountSavedPaymentMethodsAddRouteImport.update({
    id: "/add",
    path: "/add",
    getParentRoute: () => AuthenticatedAccountSavedPaymentMethodsRouteRoute,
  } as any)
const AuthenticatedAccountPassesPassIDRoute =
  AuthenticatedAccountPassesPassIDRouteImport.update({
    id: "/$passID",
    path: "/$passID",
    getParentRoute: () => AuthenticatedAccountPassesRouteRoute,
  } as any)
const QrQrLookupIDReserveEpochRouteRoute =
  QrQrLookupIDReserveEpochRouteRouteImport.update({
    id: "/reserve/$epoch",
    path: "/reserve/$epoch",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochRouteRoute =
  QrQrLookupIDPassesEpochRouteRouteImport.update({
    id: "/passes/$epoch",
    path: "/passes/$epoch",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDParkEpochRouteRoute =
  QrQrLookupIDParkEpochRouteRouteImport.update({
    id: "/park/$epoch",
    path: "/park/$epoch",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDRouteRoute =
  QrQrLookupIDGatedPamIDRouteRouteImport.update({
    id: "/gated/$pamID",
    path: "/gated/$pamID",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountRouteRoute =
  QrQrLookupIDAuthenticatedAccountRouteRouteImport.update({
    id: "/account",
    path: "/account",
    getParentRoute: () => QrQrLookupIDAuthenticatedRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDIndexRoute =
  QrQrLookupIDGatedPamIDIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountIndexRoute =
  QrQrLookupIDAuthenticatedAccountIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDReserveEpochPaymentCompleteRoute =
  QrQrLookupIDReserveEpochPaymentCompleteRouteImport.update({
    id: "/payment-complete",
    path: "/payment-complete",
    getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
  } as any)
const QrQrLookupIDParkEpochRegisterRoute =
  QrQrLookupIDParkEpochRegisterRouteImport.update({
    id: "/register",
    path: "/register",
    getParentRoute: () => QrQrLookupIDParkEpochRouteRoute,
  } as any)
const QrQrLookupIDParkEpochRatesRoute =
  QrQrLookupIDParkEpochRatesRouteImport.update({
    id: "/rates",
    path: "/rates",
    getParentRoute: () => QrQrLookupIDParkEpochRouteRoute,
  } as any)
const QrQrLookupIDParkEpochPaymentCompleteRoute =
  QrQrLookupIDParkEpochPaymentCompleteRouteImport.update({
    id: "/payment-complete",
    path: "/payment-complete",
    getParentRoute: () => QrQrLookupIDParkEpochRouteRoute,
  } as any)
const QrQrLookupIDParkEpochConfirmationRoute =
  QrQrLookupIDParkEpochConfirmationRouteImport.update({
    id: "/confirmation",
    path: "/confirmation",
    getParentRoute: () => QrQrLookupIDParkEpochRouteRoute,
  } as any)
const QrQrLookupIDParkEpochCheckoutRoute =
  QrQrLookupIDParkEpochCheckoutRouteImport.update({
    id: "/checkout",
    path: "/checkout",
    getParentRoute: () => QrQrLookupIDParkEpochRouteRoute,
  } as any)
const QrQrLookupIDParkEpochCartRoute =
  QrQrLookupIDParkEpochCartRouteImport.update({
    id: "/cart",
    path: "/cart",
    getParentRoute: () => QrQrLookupIDParkEpochRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterLookUpRoute =
  QrQrLookupIDGatedRegisterLookUpRouteImport.update({
    id: "/gated/register/look-up",
    path: "/gated/register/look-up",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterContactInfoRoute =
  QrQrLookupIDGatedRegisterContactInfoRouteImport.update({
    id: "/gated/register/contact-info",
    path: "/gated/register/contact-info",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDDevOrganismsReservationRateCardRoute =
  QrQrLookupIDDevOrganismsReservationRateCardRouteImport.update({
    id: "/organisms/reservation-rate-card",
    path: "/organisms/reservation-rate-card",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevOrganismsNavigationRoute =
  QrQrLookupIDDevOrganismsNavigationRouteImport.update({
    id: "/organisms/navigation",
    path: "/organisms/navigation",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevMoleculesRangeCalendarRoute =
  QrQrLookupIDDevMoleculesRangeCalendarRouteImport.update({
    id: "/molecules/range-calendar",
    path: "/molecules/range-calendar",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevMoleculesModalRoute =
  QrQrLookupIDDevMoleculesModalRouteImport.update({
    id: "/molecules/modal",
    path: "/molecules/modal",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevMoleculesFormsRoute =
  QrQrLookupIDDevMoleculesFormsRouteImport.update({
    id: "/molecules/forms",
    path: "/molecules/forms",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevMoleculesDateDisplayRoute =
  QrQrLookupIDDevMoleculesDateDisplayRouteImport.update({
    id: "/molecules/date-display",
    path: "/molecules/date-display",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevAtomsTypographyRoute =
  QrQrLookupIDDevAtomsTypographyRouteImport.update({
    id: "/atoms/typography",
    path: "/atoms/typography",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevAtomsIconRoute =
  QrQrLookupIDDevAtomsIconRouteImport.update({
    id: "/atoms/icon",
    path: "/atoms/icon",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevAtomsCardRoute =
  QrQrLookupIDDevAtomsCardRouteImport.update({
    id: "/atoms/card",
    path: "/atoms/card",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDDevAtomsButtonRoute =
  QrQrLookupIDDevAtomsButtonRouteImport.update({
    id: "/atoms/button",
    path: "/atoms/button",
    getParentRoute: () => QrQrLookupIDDevRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute =
  QrQrLookupIDAuthenticatedAccountUpdatePasswordRouteImport.update({
    id: "/update-password",
    path: "/update-password",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountReservationsRoute =
  QrQrLookupIDAuthenticatedAccountReservationsRouteImport.update({
    id: "/reservations",
    path: "/reservations",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountPersonalInformationRoute =
  QrQrLookupIDAuthenticatedAccountPersonalInformationRouteImport.update({
    id: "/personal-information",
    path: "/personal-information",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochPurchaseRouteRoute =
  QrQrLookupIDPassesEpochPurchaseRouteRouteImport.update({
    id: "/purchase",
    path: "/purchase",
    getParentRoute: () => QrQrLookupIDPassesEpochRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterSessionIDRouteRoute =
  QrQrLookupIDGatedRegisterSessionIDRouteRouteImport.update({
    id: "/gated/register/$sessionID",
    path: "/gated/register/$sessionID",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDSessionIDRouteRoute =
  QrQrLookupIDGatedPamIDSessionIDRouteRouteImport.update({
    id: "/$sessionID",
    path: "/$sessionID",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute =
  QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteImport.update({
    id: "/vehicles",
    path: "/vehicles",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute =
  QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteImport.update({
    id: "/saved-payment-methods",
    path: "/saved-payment-methods",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountPassesRouteRoute =
  QrQrLookupIDAuthenticatedAccountPassesRouteRouteImport.update({
    id: "/passes",
    path: "/passes",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDReserveEpochCalendarsIndexRoute =
  QrQrLookupIDReserveEpochCalendarsIndexRouteImport.update({
    id: "/calendars/",
    path: "/calendars/",
    getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochPurchaseIndexRoute =
  QrQrLookupIDPassesEpochPurchaseIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDPassesEpochPurchaseRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDLookUpIndexRoute =
  QrQrLookupIDGatedPamIDLookUpIndexRouteImport.update({
    id: "/look-up/",
    path: "/look-up/",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDSessionIDIndexRoute =
  QrQrLookupIDGatedPamIDSessionIDIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute =
  QrQrLookupIDAuthenticatedAccountVehiclesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute =
  QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountPassesIndexRoute =
  QrQrLookupIDAuthenticatedAccountPassesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountPassesRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute =
  QrQrLookupIDAuthenticatedAccountMembershipsIndexRouteImport.update({
    id: "/memberships/",
    path: "/memberships/",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute =
  QrQrLookupIDPassesEpochPurchasePaymentCompleteRouteImport.update({
    id: "/payment-complete",
    path: "/payment-complete",
    getParentRoute: () => QrQrLookupIDPassesEpochPurchaseRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochPurchaseConfirmationRoute =
  QrQrLookupIDPassesEpochPurchaseConfirmationRouteImport.update({
    id: "/confirmation",
    path: "/confirmation",
    getParentRoute: () => QrQrLookupIDPassesEpochPurchaseRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochPurchaseCheckoutRoute =
  QrQrLookupIDPassesEpochPurchaseCheckoutRouteImport.update({
    id: "/checkout",
    path: "/checkout",
    getParentRoute: () => QrQrLookupIDPassesEpochPurchaseRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochPurchaseCartRoute =
  QrQrLookupIDPassesEpochPurchaseCartRouteImport.update({
    id: "/cart",
    path: "/cart",
    getParentRoute: () => QrQrLookupIDPassesEpochPurchaseRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute =
  QrQrLookupIDGatedRegisterSessionIDPaymentStatusRouteImport.update({
    id: "/payment-status",
    path: "/payment-status",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterSessionIDExpressRoute =
  QrQrLookupIDGatedRegisterSessionIDExpressRouteImport.update({
    id: "/express",
    path: "/express",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterSessionIDConfirmationRoute =
  QrQrLookupIDGatedRegisterSessionIDConfirmationRouteImport.update({
    id: "/confirmation",
    path: "/confirmation",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterSessionIDCompleteRoute =
  QrQrLookupIDGatedRegisterSessionIDCompleteRouteImport.update({
    id: "/complete",
    path: "/complete",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterSessionIDCheckoutRoute =
  QrQrLookupIDGatedRegisterSessionIDCheckoutRouteImport.update({
    id: "/checkout",
    path: "/checkout",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedRegisterSessionIDCartRoute =
  QrQrLookupIDGatedRegisterSessionIDCartRouteImport.update({
    id: "/cart",
    path: "/cart",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDLookUpChallengeRoute =
  QrQrLookupIDGatedPamIDLookUpChallengeRouteImport.update({
    id: "/look-up/challenge",
    path: "/look-up/challenge",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute =
  QrQrLookupIDGatedPamIDSessionIDPaymentStatusRouteImport.update({
    id: "/payment-status",
    path: "/payment-status",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDSessionIDCheckoutRoute =
  QrQrLookupIDGatedPamIDSessionIDCheckoutRouteImport.update({
    id: "/checkout",
    path: "/checkout",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)
const QrQrLookupIDGatedPamIDSessionIDCartRoute =
  QrQrLookupIDGatedPamIDSessionIDCartRouteImport.update({
    id: "/cart",
    path: "/cart",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountVehiclesEditRoute =
  QrQrLookupIDAuthenticatedAccountVehiclesEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute =
  QrQrLookupIDAuthenticatedAccountVehiclesCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute =
  QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRouteImport.update({
    id: "/add",
    path: "/add",
    getParentRoute: () =>
      QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute,
  } as any)
const QrQrLookupIDAuthenticatedAccountPassesPassIDRoute =
  QrQrLookupIDAuthenticatedAccountPassesPassIDRouteImport.update({
    id: "/$passID",
    path: "/$passID",
    getParentRoute: () => QrQrLookupIDAuthenticatedAccountPassesRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochRedeemPassIDRouteRoute =
  QrQrLookupIDPassesEpochRedeemPassIDRouteRouteImport.update({
    id: "/redeem/$passID",
    path: "/redeem/$passID",
    getParentRoute: () => QrQrLookupIDPassesEpochRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochRedeemPassIDIndexRoute =
  QrQrLookupIDPassesEpochRedeemPassIDIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDPassesEpochRedeemPassIDRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute =
  QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRouteImport.update({
    id: "/redemption-complete",
    path: "/redemption-complete",
    getParentRoute: () => QrQrLookupIDPassesEpochRedeemPassIDRouteRoute,
  } as any)
const QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute =
  QrQrLookupIDPassesEpochRedeemPassIDConfirmationRouteImport.update({
    id: "/confirmation",
    path: "/confirmation",
    getParentRoute: () => QrQrLookupIDPassesEpochRedeemPassIDRouteRoute,
  } as any)
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/",
      path: "/calendars/$calendarID/dates/$year/$month/",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/$day/vehicles",
      path: "/calendars/$calendarID/dates/$year/$month/$day/vehicles",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/$day/confirmation",
      path: "/calendars/$calendarID/dates/$year/$month/$day/confirmation",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/$day/checkout",
      path: "/calendars/$calendarID/dates/$year/$month/$day/checkout",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/$day/rates/",
      path: "/calendars/$calendarID/dates/$year/$month/$day/rates/",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/$day/cart/",
      path: "/calendars/$calendarID/dates/$year/$month/$day/cart/",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress",
      path: "/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )
const QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute =
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRouteImport.update(
    {
      id: "/calendars/$calendarID/dates/$year/$month/$day/cart/expired",
      path: "/calendars/$calendarID/dates/$year/$month/$day/cart/expired",
      getParentRoute: () => QrQrLookupIDReserveEpochRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/auth": typeof AuthRouteRouteWithChildren
  "/confirmation": typeof ConfirmationRoute
  "/help": typeof HelpRoute
  "/policies": typeof PoliciesRoute
  "/privacy-policy": typeof PrivacyPolicyRoute
  "/terms-of-use": typeof TermsOfUseRoute
  "/welcome": typeof WelcomeRoute
  "/account": typeof AuthenticatedAccountRouteRouteWithChildren
  "/qr/$qrLookupID": typeof QrQrLookupIDAuthenticatedRouteRouteWithChildren
  "/auth/create-account": typeof AuthCreateAccountRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/receipt/$receiptID": typeof ReceiptReceiptIDRoute
  "/auth/": typeof AuthIndexRoute
  "/receipt/": typeof ReceiptIndexRoute
  "/account/passes": typeof AuthenticatedAccountPassesRouteRouteWithChildren
  "/account/saved-payment-methods": typeof AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  "/account/vehicles": typeof AuthenticatedAccountVehiclesRouteRouteWithChildren
  "/qr/$qrLookupID/dev": typeof QrQrLookupIDDevRouteRouteWithChildren
  "/account/personal-information": typeof AuthenticatedAccountPersonalInformationRoute
  "/account/reservations": typeof AuthenticatedAccountReservationsRoute
  "/account/update-password": typeof AuthenticatedAccountUpdatePasswordRoute
  "/auth/sign-in/set-new-password": typeof AuthSignInSetNewPasswordRoute
  "/qr/$qrLookupID/help": typeof QrQrLookupIDHelpRoute
  "/qr/$qrLookupID/policies": typeof QrQrLookupIDPoliciesRoute
  "/qr/$qrLookupID/privacy-policy": typeof QrQrLookupIDPrivacyPolicyRoute
  "/qr/$qrLookupID/terms-of-use": typeof QrQrLookupIDTermsOfUseRoute
  "/account/": typeof AuthenticatedAccountIndexRoute
  "/auth/sign-in/": typeof AuthSignInIndexRoute
  "/qr/$qrLookupID/": typeof QrQrLookupIDIndexRoute
  "/qr/$qrLookupID/account": typeof QrQrLookupIDAuthenticatedAccountRouteRouteWithChildren
  "/qr/$qrLookupID/gated/$pamID": typeof QrQrLookupIDGatedPamIDRouteRouteWithChildren
  "/qr/$qrLookupID/park/$epoch": typeof QrQrLookupIDParkEpochRouteRouteWithChildren
  "/qr/$qrLookupID/passes/$epoch": typeof QrQrLookupIDPassesEpochRouteRouteWithChildren
  "/qr/$qrLookupID/reserve/$epoch": typeof QrQrLookupIDReserveEpochRouteRouteWithChildren
  "/account/passes/$passID": typeof AuthenticatedAccountPassesPassIDRoute
  "/account/saved-payment-methods/add": typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  "/account/vehicles/create": typeof AuthenticatedAccountVehiclesCreateRoute
  "/account/vehicles/edit": typeof AuthenticatedAccountVehiclesEditRoute
  "/qr/$qrLookupID/dev/gut-check": typeof QrQrLookupIDDevGutCheckRoute
  "/qr/$qrLookupID/receipt/$receiptID": typeof QrQrLookupIDReceiptReceiptIDRoute
  "/account/memberships/": typeof AuthenticatedAccountMembershipsIndexRoute
  "/account/passes/": typeof AuthenticatedAccountPassesIndexRoute
  "/account/saved-payment-methods/": typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/account/vehicles/": typeof AuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/dev/": typeof QrQrLookupIDDevIndexRoute
  "/qr/$qrLookupID/welcome/": typeof QrQrLookupIDWelcomeIndexRoute
  "/qr/$qrLookupID/account/passes": typeof QrQrLookupIDAuthenticatedAccountPassesRouteRouteWithChildren
  "/qr/$qrLookupID/account/saved-payment-methods": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  "/qr/$qrLookupID/account/vehicles": typeof QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteWithChildren
  "/qr/$qrLookupID/gated/$pamID/$sessionID": typeof QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/gated/register/$sessionID": typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/passes/$epoch/purchase": typeof QrQrLookupIDPassesEpochPurchaseRouteRouteWithChildren
  "/qr/$qrLookupID/account/personal-information": typeof QrQrLookupIDAuthenticatedAccountPersonalInformationRoute
  "/qr/$qrLookupID/account/reservations": typeof QrQrLookupIDAuthenticatedAccountReservationsRoute
  "/qr/$qrLookupID/account/update-password": typeof QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute
  "/qr/$qrLookupID/dev/atoms/button": typeof QrQrLookupIDDevAtomsButtonRoute
  "/qr/$qrLookupID/dev/atoms/card": typeof QrQrLookupIDDevAtomsCardRoute
  "/qr/$qrLookupID/dev/atoms/icon": typeof QrQrLookupIDDevAtomsIconRoute
  "/qr/$qrLookupID/dev/atoms/typography": typeof QrQrLookupIDDevAtomsTypographyRoute
  "/qr/$qrLookupID/dev/molecules/date-display": typeof QrQrLookupIDDevMoleculesDateDisplayRoute
  "/qr/$qrLookupID/dev/molecules/forms": typeof QrQrLookupIDDevMoleculesFormsRoute
  "/qr/$qrLookupID/dev/molecules/modal": typeof QrQrLookupIDDevMoleculesModalRoute
  "/qr/$qrLookupID/dev/molecules/range-calendar": typeof QrQrLookupIDDevMoleculesRangeCalendarRoute
  "/qr/$qrLookupID/dev/organisms/navigation": typeof QrQrLookupIDDevOrganismsNavigationRoute
  "/qr/$qrLookupID/dev/organisms/reservation-rate-card": typeof QrQrLookupIDDevOrganismsReservationRateCardRoute
  "/qr/$qrLookupID/gated/register/contact-info": typeof QrQrLookupIDGatedRegisterContactInfoRoute
  "/qr/$qrLookupID/gated/register/look-up": typeof QrQrLookupIDGatedRegisterLookUpRoute
  "/qr/$qrLookupID/park/$epoch/cart": typeof QrQrLookupIDParkEpochCartRoute
  "/qr/$qrLookupID/park/$epoch/checkout": typeof QrQrLookupIDParkEpochCheckoutRoute
  "/qr/$qrLookupID/park/$epoch/confirmation": typeof QrQrLookupIDParkEpochConfirmationRoute
  "/qr/$qrLookupID/park/$epoch/payment-complete": typeof QrQrLookupIDParkEpochPaymentCompleteRoute
  "/qr/$qrLookupID/park/$epoch/rates": typeof QrQrLookupIDParkEpochRatesRoute
  "/qr/$qrLookupID/park/$epoch/register": typeof QrQrLookupIDParkEpochRegisterRoute
  "/qr/$qrLookupID/reserve/$epoch/payment-complete": typeof QrQrLookupIDReserveEpochPaymentCompleteRoute
  "/qr/$qrLookupID/account/": typeof QrQrLookupIDAuthenticatedAccountIndexRoute
  "/qr/$qrLookupID/gated/$pamID/": typeof QrQrLookupIDGatedPamIDIndexRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID": typeof QrQrLookupIDPassesEpochRedeemPassIDRouteRouteWithChildren
  "/qr/$qrLookupID/account/passes/$passID": typeof QrQrLookupIDAuthenticatedAccountPassesPassIDRoute
  "/qr/$qrLookupID/account/saved-payment-methods/add": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute
  "/qr/$qrLookupID/account/vehicles/create": typeof QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute
  "/qr/$qrLookupID/account/vehicles/edit": typeof QrQrLookupIDAuthenticatedAccountVehiclesEditRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/challenge": typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  "/qr/$qrLookupID/gated/register/$sessionID/cart": typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  "/qr/$qrLookupID/gated/register/$sessionID/checkout": typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/register/$sessionID/complete": typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  "/qr/$qrLookupID/gated/register/$sessionID/confirmation": typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  "/qr/$qrLookupID/gated/register/$sessionID/express": typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  "/qr/$qrLookupID/gated/register/$sessionID/payment-status": typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/cart": typeof QrQrLookupIDPassesEpochPurchaseCartRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/checkout": typeof QrQrLookupIDPassesEpochPurchaseCheckoutRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/confirmation": typeof QrQrLookupIDPassesEpochPurchaseConfirmationRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete": typeof QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute
  "/qr/$qrLookupID/account/memberships/": typeof QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute
  "/qr/$qrLookupID/account/passes/": typeof QrQrLookupIDAuthenticatedAccountPassesIndexRoute
  "/qr/$qrLookupID/account/saved-payment-methods/": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/qr/$qrLookupID/account/vehicles/": typeof QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/": typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/": typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/": typeof QrQrLookupIDPassesEpochPurchaseIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/": typeof QrQrLookupIDReserveEpochCalendarsIndexRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation": typeof QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete": typeof QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/": typeof QrQrLookupIDPassesEpochRedeemPassIDIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates/": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/confirmation": typeof ConfirmationRoute
  "/help": typeof HelpRoute
  "/policies": typeof PoliciesRoute
  "/privacy-policy": typeof PrivacyPolicyRoute
  "/terms-of-use": typeof TermsOfUseRoute
  "/welcome": typeof WelcomeRoute
  "/auth/create-account": typeof AuthCreateAccountRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/receipt/$receiptID": typeof ReceiptReceiptIDRoute
  "/auth": typeof AuthIndexRoute
  "/receipt": typeof ReceiptIndexRoute
  "/qr/$qrLookupID": typeof QrQrLookupIDIndexRoute
  "/account/personal-information": typeof AuthenticatedAccountPersonalInformationRoute
  "/account/reservations": typeof AuthenticatedAccountReservationsRoute
  "/account/update-password": typeof AuthenticatedAccountUpdatePasswordRoute
  "/auth/sign-in/set-new-password": typeof AuthSignInSetNewPasswordRoute
  "/qr/$qrLookupID/help": typeof QrQrLookupIDHelpRoute
  "/qr/$qrLookupID/policies": typeof QrQrLookupIDPoliciesRoute
  "/qr/$qrLookupID/privacy-policy": typeof QrQrLookupIDPrivacyPolicyRoute
  "/qr/$qrLookupID/terms-of-use": typeof QrQrLookupIDTermsOfUseRoute
  "/account": typeof AuthenticatedAccountIndexRoute
  "/auth/sign-in": typeof AuthSignInIndexRoute
  "/qr/$qrLookupID/park/$epoch": typeof QrQrLookupIDParkEpochRouteRouteWithChildren
  "/qr/$qrLookupID/passes/$epoch": typeof QrQrLookupIDPassesEpochRouteRouteWithChildren
  "/qr/$qrLookupID/reserve/$epoch": typeof QrQrLookupIDReserveEpochRouteRouteWithChildren
  "/account/passes/$passID": typeof AuthenticatedAccountPassesPassIDRoute
  "/account/saved-payment-methods/add": typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  "/account/vehicles/create": typeof AuthenticatedAccountVehiclesCreateRoute
  "/account/vehicles/edit": typeof AuthenticatedAccountVehiclesEditRoute
  "/qr/$qrLookupID/dev/gut-check": typeof QrQrLookupIDDevGutCheckRoute
  "/qr/$qrLookupID/receipt/$receiptID": typeof QrQrLookupIDReceiptReceiptIDRoute
  "/account/memberships": typeof AuthenticatedAccountMembershipsIndexRoute
  "/account/passes": typeof AuthenticatedAccountPassesIndexRoute
  "/account/saved-payment-methods": typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/account/vehicles": typeof AuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/dev": typeof QrQrLookupIDDevIndexRoute
  "/qr/$qrLookupID/welcome": typeof QrQrLookupIDWelcomeIndexRoute
  "/qr/$qrLookupID/gated/register/$sessionID": typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/account/personal-information": typeof QrQrLookupIDAuthenticatedAccountPersonalInformationRoute
  "/qr/$qrLookupID/account/reservations": typeof QrQrLookupIDAuthenticatedAccountReservationsRoute
  "/qr/$qrLookupID/account/update-password": typeof QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute
  "/qr/$qrLookupID/dev/atoms/button": typeof QrQrLookupIDDevAtomsButtonRoute
  "/qr/$qrLookupID/dev/atoms/card": typeof QrQrLookupIDDevAtomsCardRoute
  "/qr/$qrLookupID/dev/atoms/icon": typeof QrQrLookupIDDevAtomsIconRoute
  "/qr/$qrLookupID/dev/atoms/typography": typeof QrQrLookupIDDevAtomsTypographyRoute
  "/qr/$qrLookupID/dev/molecules/date-display": typeof QrQrLookupIDDevMoleculesDateDisplayRoute
  "/qr/$qrLookupID/dev/molecules/forms": typeof QrQrLookupIDDevMoleculesFormsRoute
  "/qr/$qrLookupID/dev/molecules/modal": typeof QrQrLookupIDDevMoleculesModalRoute
  "/qr/$qrLookupID/dev/molecules/range-calendar": typeof QrQrLookupIDDevMoleculesRangeCalendarRoute
  "/qr/$qrLookupID/dev/organisms/navigation": typeof QrQrLookupIDDevOrganismsNavigationRoute
  "/qr/$qrLookupID/dev/organisms/reservation-rate-card": typeof QrQrLookupIDDevOrganismsReservationRateCardRoute
  "/qr/$qrLookupID/gated/register/contact-info": typeof QrQrLookupIDGatedRegisterContactInfoRoute
  "/qr/$qrLookupID/gated/register/look-up": typeof QrQrLookupIDGatedRegisterLookUpRoute
  "/qr/$qrLookupID/park/$epoch/cart": typeof QrQrLookupIDParkEpochCartRoute
  "/qr/$qrLookupID/park/$epoch/checkout": typeof QrQrLookupIDParkEpochCheckoutRoute
  "/qr/$qrLookupID/park/$epoch/confirmation": typeof QrQrLookupIDParkEpochConfirmationRoute
  "/qr/$qrLookupID/park/$epoch/payment-complete": typeof QrQrLookupIDParkEpochPaymentCompleteRoute
  "/qr/$qrLookupID/park/$epoch/rates": typeof QrQrLookupIDParkEpochRatesRoute
  "/qr/$qrLookupID/park/$epoch/register": typeof QrQrLookupIDParkEpochRegisterRoute
  "/qr/$qrLookupID/reserve/$epoch/payment-complete": typeof QrQrLookupIDReserveEpochPaymentCompleteRoute
  "/qr/$qrLookupID/account": typeof QrQrLookupIDAuthenticatedAccountIndexRoute
  "/qr/$qrLookupID/gated/$pamID": typeof QrQrLookupIDGatedPamIDIndexRoute
  "/qr/$qrLookupID/account/passes/$passID": typeof QrQrLookupIDAuthenticatedAccountPassesPassIDRoute
  "/qr/$qrLookupID/account/saved-payment-methods/add": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute
  "/qr/$qrLookupID/account/vehicles/create": typeof QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute
  "/qr/$qrLookupID/account/vehicles/edit": typeof QrQrLookupIDAuthenticatedAccountVehiclesEditRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/challenge": typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  "/qr/$qrLookupID/gated/register/$sessionID/cart": typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  "/qr/$qrLookupID/gated/register/$sessionID/checkout": typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/register/$sessionID/complete": typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  "/qr/$qrLookupID/gated/register/$sessionID/confirmation": typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  "/qr/$qrLookupID/gated/register/$sessionID/express": typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  "/qr/$qrLookupID/gated/register/$sessionID/payment-status": typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/cart": typeof QrQrLookupIDPassesEpochPurchaseCartRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/checkout": typeof QrQrLookupIDPassesEpochPurchaseCheckoutRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/confirmation": typeof QrQrLookupIDPassesEpochPurchaseConfirmationRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete": typeof QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute
  "/qr/$qrLookupID/account/memberships": typeof QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute
  "/qr/$qrLookupID/account/passes": typeof QrQrLookupIDAuthenticatedAccountPassesIndexRoute
  "/qr/$qrLookupID/account/saved-payment-methods": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/qr/$qrLookupID/account/vehicles": typeof QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID": typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/look-up": typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
  "/qr/$qrLookupID/passes/$epoch/purchase": typeof QrQrLookupIDPassesEpochPurchaseIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars": typeof QrQrLookupIDReserveEpochCalendarsIndexRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation": typeof QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete": typeof QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID": typeof QrQrLookupIDPassesEpochRedeemPassIDIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren
  "/auth": typeof AuthRouteRouteWithChildren
  "/confirmation": typeof ConfirmationRoute
  "/help": typeof HelpRoute
  "/policies": typeof PoliciesRoute
  "/privacy-policy": typeof PrivacyPolicyRoute
  "/terms-of-use": typeof TermsOfUseRoute
  "/welcome": typeof WelcomeRoute
  "/_authenticated/account": typeof AuthenticatedAccountRouteRouteWithChildren
  "/qr/$qrLookupID": typeof QrQrLookupIDRouteRouteWithChildren
  "/auth/create-account": typeof AuthCreateAccountRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/receipt/$receiptID": typeof ReceiptReceiptIDRoute
  "/auth/": typeof AuthIndexRoute
  "/receipt/": typeof ReceiptIndexRoute
  "/_authenticated/account/passes": typeof AuthenticatedAccountPassesRouteRouteWithChildren
  "/_authenticated/account/saved-payment-methods": typeof AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  "/_authenticated/account/vehicles": typeof AuthenticatedAccountVehiclesRouteRouteWithChildren
  "/qr/$qrLookupID/_authenticated": typeof QrQrLookupIDAuthenticatedRouteRouteWithChildren
  "/qr/$qrLookupID/dev": typeof QrQrLookupIDDevRouteRouteWithChildren
  "/_authenticated/account/personal-information": typeof AuthenticatedAccountPersonalInformationRoute
  "/_authenticated/account/reservations": typeof AuthenticatedAccountReservationsRoute
  "/_authenticated/account/update-password": typeof AuthenticatedAccountUpdatePasswordRoute
  "/auth/sign-in/set-new-password": typeof AuthSignInSetNewPasswordRoute
  "/qr/$qrLookupID/help": typeof QrQrLookupIDHelpRoute
  "/qr/$qrLookupID/policies": typeof QrQrLookupIDPoliciesRoute
  "/qr/$qrLookupID/privacy-policy": typeof QrQrLookupIDPrivacyPolicyRoute
  "/qr/$qrLookupID/terms-of-use": typeof QrQrLookupIDTermsOfUseRoute
  "/_authenticated/account/": typeof AuthenticatedAccountIndexRoute
  "/auth/sign-in/": typeof AuthSignInIndexRoute
  "/qr/$qrLookupID/": typeof QrQrLookupIDIndexRoute
  "/qr/$qrLookupID/_authenticated/account": typeof QrQrLookupIDAuthenticatedAccountRouteRouteWithChildren
  "/qr/$qrLookupID/gated/$pamID": typeof QrQrLookupIDGatedPamIDRouteRouteWithChildren
  "/qr/$qrLookupID/park/$epoch": typeof QrQrLookupIDParkEpochRouteRouteWithChildren
  "/qr/$qrLookupID/passes/$epoch": typeof QrQrLookupIDPassesEpochRouteRouteWithChildren
  "/qr/$qrLookupID/reserve/$epoch": typeof QrQrLookupIDReserveEpochRouteRouteWithChildren
  "/_authenticated/account/passes/$passID": typeof AuthenticatedAccountPassesPassIDRoute
  "/_authenticated/account/saved-payment-methods/add": typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  "/_authenticated/account/vehicles/create": typeof AuthenticatedAccountVehiclesCreateRoute
  "/_authenticated/account/vehicles/edit": typeof AuthenticatedAccountVehiclesEditRoute
  "/qr/$qrLookupID/dev/gut-check": typeof QrQrLookupIDDevGutCheckRoute
  "/qr/$qrLookupID/receipt/$receiptID": typeof QrQrLookupIDReceiptReceiptIDRoute
  "/_authenticated/account/memberships/": typeof AuthenticatedAccountMembershipsIndexRoute
  "/_authenticated/account/passes/": typeof AuthenticatedAccountPassesIndexRoute
  "/_authenticated/account/saved-payment-methods/": typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/_authenticated/account/vehicles/": typeof AuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/dev/": typeof QrQrLookupIDDevIndexRoute
  "/qr/$qrLookupID/welcome/": typeof QrQrLookupIDWelcomeIndexRoute
  "/qr/$qrLookupID/_authenticated/account/passes": typeof QrQrLookupIDAuthenticatedAccountPassesRouteRouteWithChildren
  "/qr/$qrLookupID/_authenticated/account/saved-payment-methods": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  "/qr/$qrLookupID/_authenticated/account/vehicles": typeof QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteWithChildren
  "/qr/$qrLookupID/gated/$pamID/$sessionID": typeof QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/gated/register/$sessionID": typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/passes/$epoch/purchase": typeof QrQrLookupIDPassesEpochPurchaseRouteRouteWithChildren
  "/qr/$qrLookupID/_authenticated/account/personal-information": typeof QrQrLookupIDAuthenticatedAccountPersonalInformationRoute
  "/qr/$qrLookupID/_authenticated/account/reservations": typeof QrQrLookupIDAuthenticatedAccountReservationsRoute
  "/qr/$qrLookupID/_authenticated/account/update-password": typeof QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute
  "/qr/$qrLookupID/dev/atoms/button": typeof QrQrLookupIDDevAtomsButtonRoute
  "/qr/$qrLookupID/dev/atoms/card": typeof QrQrLookupIDDevAtomsCardRoute
  "/qr/$qrLookupID/dev/atoms/icon": typeof QrQrLookupIDDevAtomsIconRoute
  "/qr/$qrLookupID/dev/atoms/typography": typeof QrQrLookupIDDevAtomsTypographyRoute
  "/qr/$qrLookupID/dev/molecules/date-display": typeof QrQrLookupIDDevMoleculesDateDisplayRoute
  "/qr/$qrLookupID/dev/molecules/forms": typeof QrQrLookupIDDevMoleculesFormsRoute
  "/qr/$qrLookupID/dev/molecules/modal": typeof QrQrLookupIDDevMoleculesModalRoute
  "/qr/$qrLookupID/dev/molecules/range-calendar": typeof QrQrLookupIDDevMoleculesRangeCalendarRoute
  "/qr/$qrLookupID/dev/organisms/navigation": typeof QrQrLookupIDDevOrganismsNavigationRoute
  "/qr/$qrLookupID/dev/organisms/reservation-rate-card": typeof QrQrLookupIDDevOrganismsReservationRateCardRoute
  "/qr/$qrLookupID/gated/register/contact-info": typeof QrQrLookupIDGatedRegisterContactInfoRoute
  "/qr/$qrLookupID/gated/register/look-up": typeof QrQrLookupIDGatedRegisterLookUpRoute
  "/qr/$qrLookupID/park/$epoch/cart": typeof QrQrLookupIDParkEpochCartRoute
  "/qr/$qrLookupID/park/$epoch/checkout": typeof QrQrLookupIDParkEpochCheckoutRoute
  "/qr/$qrLookupID/park/$epoch/confirmation": typeof QrQrLookupIDParkEpochConfirmationRoute
  "/qr/$qrLookupID/park/$epoch/payment-complete": typeof QrQrLookupIDParkEpochPaymentCompleteRoute
  "/qr/$qrLookupID/park/$epoch/rates": typeof QrQrLookupIDParkEpochRatesRoute
  "/qr/$qrLookupID/park/$epoch/register": typeof QrQrLookupIDParkEpochRegisterRoute
  "/qr/$qrLookupID/reserve/$epoch/payment-complete": typeof QrQrLookupIDReserveEpochPaymentCompleteRoute
  "/qr/$qrLookupID/_authenticated/account/": typeof QrQrLookupIDAuthenticatedAccountIndexRoute
  "/qr/$qrLookupID/gated/$pamID/": typeof QrQrLookupIDGatedPamIDIndexRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID": typeof QrQrLookupIDPassesEpochRedeemPassIDRouteRouteWithChildren
  "/qr/$qrLookupID/_authenticated/account/passes/$passID": typeof QrQrLookupIDAuthenticatedAccountPassesPassIDRoute
  "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/add": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute
  "/qr/$qrLookupID/_authenticated/account/vehicles/create": typeof QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute
  "/qr/$qrLookupID/_authenticated/account/vehicles/edit": typeof QrQrLookupIDAuthenticatedAccountVehiclesEditRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/challenge": typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  "/qr/$qrLookupID/gated/register/$sessionID/cart": typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  "/qr/$qrLookupID/gated/register/$sessionID/checkout": typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/register/$sessionID/complete": typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  "/qr/$qrLookupID/gated/register/$sessionID/confirmation": typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  "/qr/$qrLookupID/gated/register/$sessionID/express": typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  "/qr/$qrLookupID/gated/register/$sessionID/payment-status": typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/cart": typeof QrQrLookupIDPassesEpochPurchaseCartRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/checkout": typeof QrQrLookupIDPassesEpochPurchaseCheckoutRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/confirmation": typeof QrQrLookupIDPassesEpochPurchaseConfirmationRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete": typeof QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute
  "/qr/$qrLookupID/_authenticated/account/memberships/": typeof QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute
  "/qr/$qrLookupID/_authenticated/account/passes/": typeof QrQrLookupIDAuthenticatedAccountPassesIndexRoute
  "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/": typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/qr/$qrLookupID/_authenticated/account/vehicles/": typeof QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/": typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/": typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
  "/qr/$qrLookupID/passes/$epoch/purchase/": typeof QrQrLookupIDPassesEpochPurchaseIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/": typeof QrQrLookupIDReserveEpochCalendarsIndexRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation": typeof QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete": typeof QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID/": typeof QrQrLookupIDPassesEpochRedeemPassIDIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates/": typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/auth"
    | "/confirmation"
    | "/help"
    | "/policies"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/welcome"
    | "/account"
    | "/qr/$qrLookupID"
    | "/auth/create-account"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/receipt/$receiptID"
    | "/auth/"
    | "/receipt/"
    | "/account/passes"
    | "/account/saved-payment-methods"
    | "/account/vehicles"
    | "/qr/$qrLookupID/dev"
    | "/account/personal-information"
    | "/account/reservations"
    | "/account/update-password"
    | "/auth/sign-in/set-new-password"
    | "/qr/$qrLookupID/help"
    | "/qr/$qrLookupID/policies"
    | "/qr/$qrLookupID/privacy-policy"
    | "/qr/$qrLookupID/terms-of-use"
    | "/account/"
    | "/auth/sign-in/"
    | "/qr/$qrLookupID/"
    | "/qr/$qrLookupID/account"
    | "/qr/$qrLookupID/gated/$pamID"
    | "/qr/$qrLookupID/park/$epoch"
    | "/qr/$qrLookupID/passes/$epoch"
    | "/qr/$qrLookupID/reserve/$epoch"
    | "/account/passes/$passID"
    | "/account/saved-payment-methods/add"
    | "/account/vehicles/create"
    | "/account/vehicles/edit"
    | "/qr/$qrLookupID/dev/gut-check"
    | "/qr/$qrLookupID/receipt/$receiptID"
    | "/account/memberships/"
    | "/account/passes/"
    | "/account/saved-payment-methods/"
    | "/account/vehicles/"
    | "/qr/$qrLookupID/dev/"
    | "/qr/$qrLookupID/welcome/"
    | "/qr/$qrLookupID/account/passes"
    | "/qr/$qrLookupID/account/saved-payment-methods"
    | "/qr/$qrLookupID/account/vehicles"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID"
    | "/qr/$qrLookupID/gated/register/$sessionID"
    | "/qr/$qrLookupID/passes/$epoch/purchase"
    | "/qr/$qrLookupID/account/personal-information"
    | "/qr/$qrLookupID/account/reservations"
    | "/qr/$qrLookupID/account/update-password"
    | "/qr/$qrLookupID/dev/atoms/button"
    | "/qr/$qrLookupID/dev/atoms/card"
    | "/qr/$qrLookupID/dev/atoms/icon"
    | "/qr/$qrLookupID/dev/atoms/typography"
    | "/qr/$qrLookupID/dev/molecules/date-display"
    | "/qr/$qrLookupID/dev/molecules/forms"
    | "/qr/$qrLookupID/dev/molecules/modal"
    | "/qr/$qrLookupID/dev/molecules/range-calendar"
    | "/qr/$qrLookupID/dev/organisms/navigation"
    | "/qr/$qrLookupID/dev/organisms/reservation-rate-card"
    | "/qr/$qrLookupID/gated/register/contact-info"
    | "/qr/$qrLookupID/gated/register/look-up"
    | "/qr/$qrLookupID/park/$epoch/cart"
    | "/qr/$qrLookupID/park/$epoch/checkout"
    | "/qr/$qrLookupID/park/$epoch/confirmation"
    | "/qr/$qrLookupID/park/$epoch/payment-complete"
    | "/qr/$qrLookupID/park/$epoch/rates"
    | "/qr/$qrLookupID/park/$epoch/register"
    | "/qr/$qrLookupID/reserve/$epoch/payment-complete"
    | "/qr/$qrLookupID/account/"
    | "/qr/$qrLookupID/gated/$pamID/"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID"
    | "/qr/$qrLookupID/account/passes/$passID"
    | "/qr/$qrLookupID/account/saved-payment-methods/add"
    | "/qr/$qrLookupID/account/vehicles/create"
    | "/qr/$qrLookupID/account/vehicles/edit"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
    | "/qr/$qrLookupID/gated/register/$sessionID/cart"
    | "/qr/$qrLookupID/gated/register/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/register/$sessionID/complete"
    | "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
    | "/qr/$qrLookupID/gated/register/$sessionID/express"
    | "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
    | "/qr/$qrLookupID/passes/$epoch/purchase/cart"
    | "/qr/$qrLookupID/passes/$epoch/purchase/checkout"
    | "/qr/$qrLookupID/passes/$epoch/purchase/confirmation"
    | "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete"
    | "/qr/$qrLookupID/account/memberships/"
    | "/qr/$qrLookupID/account/passes/"
    | "/qr/$qrLookupID/account/saved-payment-methods/"
    | "/qr/$qrLookupID/account/vehicles/"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/"
    | "/qr/$qrLookupID/gated/$pamID/look-up/"
    | "/qr/$qrLookupID/passes/$epoch/purchase/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/confirmation"
    | "/help"
    | "/policies"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/welcome"
    | "/auth/create-account"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/receipt/$receiptID"
    | "/auth"
    | "/receipt"
    | "/qr/$qrLookupID"
    | "/account/personal-information"
    | "/account/reservations"
    | "/account/update-password"
    | "/auth/sign-in/set-new-password"
    | "/qr/$qrLookupID/help"
    | "/qr/$qrLookupID/policies"
    | "/qr/$qrLookupID/privacy-policy"
    | "/qr/$qrLookupID/terms-of-use"
    | "/account"
    | "/auth/sign-in"
    | "/qr/$qrLookupID/park/$epoch"
    | "/qr/$qrLookupID/passes/$epoch"
    | "/qr/$qrLookupID/reserve/$epoch"
    | "/account/passes/$passID"
    | "/account/saved-payment-methods/add"
    | "/account/vehicles/create"
    | "/account/vehicles/edit"
    | "/qr/$qrLookupID/dev/gut-check"
    | "/qr/$qrLookupID/receipt/$receiptID"
    | "/account/memberships"
    | "/account/passes"
    | "/account/saved-payment-methods"
    | "/account/vehicles"
    | "/qr/$qrLookupID/dev"
    | "/qr/$qrLookupID/welcome"
    | "/qr/$qrLookupID/gated/register/$sessionID"
    | "/qr/$qrLookupID/account/personal-information"
    | "/qr/$qrLookupID/account/reservations"
    | "/qr/$qrLookupID/account/update-password"
    | "/qr/$qrLookupID/dev/atoms/button"
    | "/qr/$qrLookupID/dev/atoms/card"
    | "/qr/$qrLookupID/dev/atoms/icon"
    | "/qr/$qrLookupID/dev/atoms/typography"
    | "/qr/$qrLookupID/dev/molecules/date-display"
    | "/qr/$qrLookupID/dev/molecules/forms"
    | "/qr/$qrLookupID/dev/molecules/modal"
    | "/qr/$qrLookupID/dev/molecules/range-calendar"
    | "/qr/$qrLookupID/dev/organisms/navigation"
    | "/qr/$qrLookupID/dev/organisms/reservation-rate-card"
    | "/qr/$qrLookupID/gated/register/contact-info"
    | "/qr/$qrLookupID/gated/register/look-up"
    | "/qr/$qrLookupID/park/$epoch/cart"
    | "/qr/$qrLookupID/park/$epoch/checkout"
    | "/qr/$qrLookupID/park/$epoch/confirmation"
    | "/qr/$qrLookupID/park/$epoch/payment-complete"
    | "/qr/$qrLookupID/park/$epoch/rates"
    | "/qr/$qrLookupID/park/$epoch/register"
    | "/qr/$qrLookupID/reserve/$epoch/payment-complete"
    | "/qr/$qrLookupID/account"
    | "/qr/$qrLookupID/gated/$pamID"
    | "/qr/$qrLookupID/account/passes/$passID"
    | "/qr/$qrLookupID/account/saved-payment-methods/add"
    | "/qr/$qrLookupID/account/vehicles/create"
    | "/qr/$qrLookupID/account/vehicles/edit"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
    | "/qr/$qrLookupID/gated/register/$sessionID/cart"
    | "/qr/$qrLookupID/gated/register/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/register/$sessionID/complete"
    | "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
    | "/qr/$qrLookupID/gated/register/$sessionID/express"
    | "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
    | "/qr/$qrLookupID/passes/$epoch/purchase/cart"
    | "/qr/$qrLookupID/passes/$epoch/purchase/checkout"
    | "/qr/$qrLookupID/passes/$epoch/purchase/confirmation"
    | "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete"
    | "/qr/$qrLookupID/account/memberships"
    | "/qr/$qrLookupID/account/passes"
    | "/qr/$qrLookupID/account/saved-payment-methods"
    | "/qr/$qrLookupID/account/vehicles"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID"
    | "/qr/$qrLookupID/gated/$pamID/look-up"
    | "/qr/$qrLookupID/passes/$epoch/purchase"
    | "/qr/$qrLookupID/reserve/$epoch/calendars"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates"
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/auth"
    | "/confirmation"
    | "/help"
    | "/policies"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/welcome"
    | "/_authenticated/account"
    | "/qr/$qrLookupID"
    | "/auth/create-account"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/receipt/$receiptID"
    | "/auth/"
    | "/receipt/"
    | "/_authenticated/account/passes"
    | "/_authenticated/account/saved-payment-methods"
    | "/_authenticated/account/vehicles"
    | "/qr/$qrLookupID/_authenticated"
    | "/qr/$qrLookupID/dev"
    | "/_authenticated/account/personal-information"
    | "/_authenticated/account/reservations"
    | "/_authenticated/account/update-password"
    | "/auth/sign-in/set-new-password"
    | "/qr/$qrLookupID/help"
    | "/qr/$qrLookupID/policies"
    | "/qr/$qrLookupID/privacy-policy"
    | "/qr/$qrLookupID/terms-of-use"
    | "/_authenticated/account/"
    | "/auth/sign-in/"
    | "/qr/$qrLookupID/"
    | "/qr/$qrLookupID/_authenticated/account"
    | "/qr/$qrLookupID/gated/$pamID"
    | "/qr/$qrLookupID/park/$epoch"
    | "/qr/$qrLookupID/passes/$epoch"
    | "/qr/$qrLookupID/reserve/$epoch"
    | "/_authenticated/account/passes/$passID"
    | "/_authenticated/account/saved-payment-methods/add"
    | "/_authenticated/account/vehicles/create"
    | "/_authenticated/account/vehicles/edit"
    | "/qr/$qrLookupID/dev/gut-check"
    | "/qr/$qrLookupID/receipt/$receiptID"
    | "/_authenticated/account/memberships/"
    | "/_authenticated/account/passes/"
    | "/_authenticated/account/saved-payment-methods/"
    | "/_authenticated/account/vehicles/"
    | "/qr/$qrLookupID/dev/"
    | "/qr/$qrLookupID/welcome/"
    | "/qr/$qrLookupID/_authenticated/account/passes"
    | "/qr/$qrLookupID/_authenticated/account/saved-payment-methods"
    | "/qr/$qrLookupID/_authenticated/account/vehicles"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID"
    | "/qr/$qrLookupID/gated/register/$sessionID"
    | "/qr/$qrLookupID/passes/$epoch/purchase"
    | "/qr/$qrLookupID/_authenticated/account/personal-information"
    | "/qr/$qrLookupID/_authenticated/account/reservations"
    | "/qr/$qrLookupID/_authenticated/account/update-password"
    | "/qr/$qrLookupID/dev/atoms/button"
    | "/qr/$qrLookupID/dev/atoms/card"
    | "/qr/$qrLookupID/dev/atoms/icon"
    | "/qr/$qrLookupID/dev/atoms/typography"
    | "/qr/$qrLookupID/dev/molecules/date-display"
    | "/qr/$qrLookupID/dev/molecules/forms"
    | "/qr/$qrLookupID/dev/molecules/modal"
    | "/qr/$qrLookupID/dev/molecules/range-calendar"
    | "/qr/$qrLookupID/dev/organisms/navigation"
    | "/qr/$qrLookupID/dev/organisms/reservation-rate-card"
    | "/qr/$qrLookupID/gated/register/contact-info"
    | "/qr/$qrLookupID/gated/register/look-up"
    | "/qr/$qrLookupID/park/$epoch/cart"
    | "/qr/$qrLookupID/park/$epoch/checkout"
    | "/qr/$qrLookupID/park/$epoch/confirmation"
    | "/qr/$qrLookupID/park/$epoch/payment-complete"
    | "/qr/$qrLookupID/park/$epoch/rates"
    | "/qr/$qrLookupID/park/$epoch/register"
    | "/qr/$qrLookupID/reserve/$epoch/payment-complete"
    | "/qr/$qrLookupID/_authenticated/account/"
    | "/qr/$qrLookupID/gated/$pamID/"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID"
    | "/qr/$qrLookupID/_authenticated/account/passes/$passID"
    | "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/add"
    | "/qr/$qrLookupID/_authenticated/account/vehicles/create"
    | "/qr/$qrLookupID/_authenticated/account/vehicles/edit"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
    | "/qr/$qrLookupID/gated/register/$sessionID/cart"
    | "/qr/$qrLookupID/gated/register/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/register/$sessionID/complete"
    | "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
    | "/qr/$qrLookupID/gated/register/$sessionID/express"
    | "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
    | "/qr/$qrLookupID/passes/$epoch/purchase/cart"
    | "/qr/$qrLookupID/passes/$epoch/purchase/checkout"
    | "/qr/$qrLookupID/passes/$epoch/purchase/confirmation"
    | "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete"
    | "/qr/$qrLookupID/_authenticated/account/memberships/"
    | "/qr/$qrLookupID/_authenticated/account/passes/"
    | "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/"
    | "/qr/$qrLookupID/_authenticated/account/vehicles/"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/"
    | "/qr/$qrLookupID/gated/$pamID/look-up/"
    | "/qr/$qrLookupID/passes/$epoch/purchase/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete"
    | "/qr/$qrLookupID/passes/$epoch/redeem/$passID/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/"
    | "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ConfirmationRoute: typeof ConfirmationRoute
  HelpRoute: typeof HelpRoute
  PoliciesRoute: typeof PoliciesRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
  WelcomeRoute: typeof WelcomeRoute
  QrQrLookupIDRouteRoute: typeof QrQrLookupIDRouteRouteWithChildren
  ReceiptReceiptIDRoute: typeof ReceiptReceiptIDRoute
  ReceiptIndexRoute: typeof ReceiptIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/welcome": {
      id: "/welcome"
      path: "/welcome"
      fullPath: "/welcome"
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/terms-of-use": {
      id: "/terms-of-use"
      path: "/terms-of-use"
      fullPath: "/terms-of-use"
      preLoaderRoute: typeof TermsOfUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy-policy": {
      id: "/privacy-policy"
      path: "/privacy-policy"
      fullPath: "/privacy-policy"
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/policies": {
      id: "/policies"
      path: "/policies"
      fullPath: "/policies"
      preLoaderRoute: typeof PoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/help": {
      id: "/help"
      path: "/help"
      fullPath: "/help"
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/confirmation": {
      id: "/confirmation"
      path: "/confirmation"
      fullPath: "/confirmation"
      preLoaderRoute: typeof ConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth": {
      id: "/auth"
      path: "/auth"
      fullPath: "/auth"
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/receipt/": {
      id: "/receipt/"
      path: "/receipt"
      fullPath: "/receipt/"
      preLoaderRoute: typeof ReceiptIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/": {
      id: "/auth/"
      path: "/"
      fullPath: "/auth/"
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    "/receipt/$receiptID": {
      id: "/receipt/$receiptID"
      path: "/receipt/$receiptID"
      fullPath: "/receipt/$receiptID"
      preLoaderRoute: typeof ReceiptReceiptIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/verify": {
      id: "/auth/verify"
      path: "/verify"
      fullPath: "/auth/verify"
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    "/auth/reset-password": {
      id: "/auth/reset-password"
      path: "/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    "/auth/forgot-password": {
      id: "/auth/forgot-password"
      path: "/forgot-password"
      fullPath: "/auth/forgot-password"
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    "/auth/create-account": {
      id: "/auth/create-account"
      path: "/create-account"
      fullPath: "/auth/create-account"
      preLoaderRoute: typeof AuthCreateAccountRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    "/qr/$qrLookupID": {
      id: "/qr/$qrLookupID"
      path: "/qr/$qrLookupID"
      fullPath: "/qr/$qrLookupID"
      preLoaderRoute: typeof QrQrLookupIDRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/account": {
      id: "/_authenticated/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AuthenticatedAccountRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/qr/$qrLookupID/": {
      id: "/qr/$qrLookupID/"
      path: "/"
      fullPath: "/qr/$qrLookupID/"
      preLoaderRoute: typeof QrQrLookupIDIndexRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/auth/sign-in/": {
      id: "/auth/sign-in/"
      path: "/sign-in"
      fullPath: "/auth/sign-in/"
      preLoaderRoute: typeof AuthSignInIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    "/_authenticated/account/": {
      id: "/_authenticated/account/"
      path: "/"
      fullPath: "/account/"
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/terms-of-use": {
      id: "/qr/$qrLookupID/terms-of-use"
      path: "/terms-of-use"
      fullPath: "/qr/$qrLookupID/terms-of-use"
      preLoaderRoute: typeof QrQrLookupIDTermsOfUseRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/privacy-policy": {
      id: "/qr/$qrLookupID/privacy-policy"
      path: "/privacy-policy"
      fullPath: "/qr/$qrLookupID/privacy-policy"
      preLoaderRoute: typeof QrQrLookupIDPrivacyPolicyRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/policies": {
      id: "/qr/$qrLookupID/policies"
      path: "/policies"
      fullPath: "/qr/$qrLookupID/policies"
      preLoaderRoute: typeof QrQrLookupIDPoliciesRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/help": {
      id: "/qr/$qrLookupID/help"
      path: "/help"
      fullPath: "/qr/$qrLookupID/help"
      preLoaderRoute: typeof QrQrLookupIDHelpRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/auth/sign-in/set-new-password": {
      id: "/auth/sign-in/set-new-password"
      path: "/sign-in/set-new-password"
      fullPath: "/auth/sign-in/set-new-password"
      preLoaderRoute: typeof AuthSignInSetNewPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    "/_authenticated/account/update-password": {
      id: "/_authenticated/account/update-password"
      path: "/update-password"
      fullPath: "/account/update-password"
      preLoaderRoute: typeof AuthenticatedAccountUpdatePasswordRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/_authenticated/account/reservations": {
      id: "/_authenticated/account/reservations"
      path: "/reservations"
      fullPath: "/account/reservations"
      preLoaderRoute: typeof AuthenticatedAccountReservationsRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/_authenticated/account/personal-information": {
      id: "/_authenticated/account/personal-information"
      path: "/personal-information"
      fullPath: "/account/personal-information"
      preLoaderRoute: typeof AuthenticatedAccountPersonalInformationRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/dev": {
      id: "/qr/$qrLookupID/dev"
      path: "/dev"
      fullPath: "/qr/$qrLookupID/dev"
      preLoaderRoute: typeof QrQrLookupIDDevRouteRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/_authenticated": {
      id: "/qr/$qrLookupID/_authenticated"
      path: ""
      fullPath: "/qr/$qrLookupID"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedRouteRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/_authenticated/account/vehicles": {
      id: "/_authenticated/account/vehicles"
      path: "/vehicles"
      fullPath: "/account/vehicles"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/_authenticated/account/saved-payment-methods": {
      id: "/_authenticated/account/saved-payment-methods"
      path: "/saved-payment-methods"
      fullPath: "/account/saved-payment-methods"
      preLoaderRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/_authenticated/account/passes": {
      id: "/_authenticated/account/passes"
      path: "/passes"
      fullPath: "/account/passes"
      preLoaderRoute: typeof AuthenticatedAccountPassesRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/welcome/": {
      id: "/qr/$qrLookupID/welcome/"
      path: "/welcome"
      fullPath: "/qr/$qrLookupID/welcome/"
      preLoaderRoute: typeof QrQrLookupIDWelcomeIndexRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/dev/": {
      id: "/qr/$qrLookupID/dev/"
      path: "/"
      fullPath: "/qr/$qrLookupID/dev/"
      preLoaderRoute: typeof QrQrLookupIDDevIndexRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/_authenticated/account/vehicles/": {
      id: "/_authenticated/account/vehicles/"
      path: "/"
      fullPath: "/account/vehicles/"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountVehiclesRouteRoute
    }
    "/_authenticated/account/saved-payment-methods/": {
      id: "/_authenticated/account/saved-payment-methods/"
      path: "/"
      fullPath: "/account/saved-payment-methods/"
      preLoaderRoute: typeof AuthenticatedAccountSavedPaymentMethodsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteRoute
    }
    "/_authenticated/account/passes/": {
      id: "/_authenticated/account/passes/"
      path: "/"
      fullPath: "/account/passes/"
      preLoaderRoute: typeof AuthenticatedAccountPassesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountPassesRouteRoute
    }
    "/_authenticated/account/memberships/": {
      id: "/_authenticated/account/memberships/"
      path: "/memberships"
      fullPath: "/account/memberships/"
      preLoaderRoute: typeof AuthenticatedAccountMembershipsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/receipt/$receiptID": {
      id: "/qr/$qrLookupID/receipt/$receiptID"
      path: "/receipt/$receiptID"
      fullPath: "/qr/$qrLookupID/receipt/$receiptID"
      preLoaderRoute: typeof QrQrLookupIDReceiptReceiptIDRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/dev/gut-check": {
      id: "/qr/$qrLookupID/dev/gut-check"
      path: "/gut-check"
      fullPath: "/qr/$qrLookupID/dev/gut-check"
      preLoaderRoute: typeof QrQrLookupIDDevGutCheckRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/_authenticated/account/vehicles/edit": {
      id: "/_authenticated/account/vehicles/edit"
      path: "/edit"
      fullPath: "/account/vehicles/edit"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesEditRouteImport
      parentRoute: typeof AuthenticatedAccountVehiclesRouteRoute
    }
    "/_authenticated/account/vehicles/create": {
      id: "/_authenticated/account/vehicles/create"
      path: "/create"
      fullPath: "/account/vehicles/create"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesCreateRouteImport
      parentRoute: typeof AuthenticatedAccountVehiclesRouteRoute
    }
    "/_authenticated/account/saved-payment-methods/add": {
      id: "/_authenticated/account/saved-payment-methods/add"
      path: "/add"
      fullPath: "/account/saved-payment-methods/add"
      preLoaderRoute: typeof AuthenticatedAccountSavedPaymentMethodsAddRouteImport
      parentRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteRoute
    }
    "/_authenticated/account/passes/$passID": {
      id: "/_authenticated/account/passes/$passID"
      path: "/$passID"
      fullPath: "/account/passes/$passID"
      preLoaderRoute: typeof AuthenticatedAccountPassesPassIDRouteImport
      parentRoute: typeof AuthenticatedAccountPassesRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch": {
      id: "/qr/$qrLookupID/reserve/$epoch"
      path: "/reserve/$epoch"
      fullPath: "/qr/$qrLookupID/reserve/$epoch"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochRouteRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch": {
      id: "/qr/$qrLookupID/passes/$epoch"
      path: "/passes/$epoch"
      fullPath: "/qr/$qrLookupID/passes/$epoch"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochRouteRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/park/$epoch": {
      id: "/qr/$qrLookupID/park/$epoch"
      path: "/park/$epoch"
      fullPath: "/qr/$qrLookupID/park/$epoch"
      preLoaderRoute: typeof QrQrLookupIDParkEpochRouteRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID": {
      id: "/qr/$qrLookupID/gated/$pamID"
      path: "/gated/$pamID"
      fullPath: "/qr/$qrLookupID/gated/$pamID"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDRouteRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account": {
      id: "/qr/$qrLookupID/_authenticated/account"
      path: "/account"
      fullPath: "/qr/$qrLookupID/account"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/": {
      id: "/qr/$qrLookupID/gated/$pamID/"
      path: "/"
      fullPath: "/qr/$qrLookupID/gated/$pamID/"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDIndexRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/": {
      id: "/qr/$qrLookupID/_authenticated/account/"
      path: "/"
      fullPath: "/qr/$qrLookupID/account/"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountIndexRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/payment-complete": {
      id: "/qr/$qrLookupID/reserve/$epoch/payment-complete"
      path: "/payment-complete"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/payment-complete"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochPaymentCompleteRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/park/$epoch/register": {
      id: "/qr/$qrLookupID/park/$epoch/register"
      path: "/register"
      fullPath: "/qr/$qrLookupID/park/$epoch/register"
      preLoaderRoute: typeof QrQrLookupIDParkEpochRegisterRouteImport
      parentRoute: typeof QrQrLookupIDParkEpochRouteRoute
    }
    "/qr/$qrLookupID/park/$epoch/rates": {
      id: "/qr/$qrLookupID/park/$epoch/rates"
      path: "/rates"
      fullPath: "/qr/$qrLookupID/park/$epoch/rates"
      preLoaderRoute: typeof QrQrLookupIDParkEpochRatesRouteImport
      parentRoute: typeof QrQrLookupIDParkEpochRouteRoute
    }
    "/qr/$qrLookupID/park/$epoch/payment-complete": {
      id: "/qr/$qrLookupID/park/$epoch/payment-complete"
      path: "/payment-complete"
      fullPath: "/qr/$qrLookupID/park/$epoch/payment-complete"
      preLoaderRoute: typeof QrQrLookupIDParkEpochPaymentCompleteRouteImport
      parentRoute: typeof QrQrLookupIDParkEpochRouteRoute
    }
    "/qr/$qrLookupID/park/$epoch/confirmation": {
      id: "/qr/$qrLookupID/park/$epoch/confirmation"
      path: "/confirmation"
      fullPath: "/qr/$qrLookupID/park/$epoch/confirmation"
      preLoaderRoute: typeof QrQrLookupIDParkEpochConfirmationRouteImport
      parentRoute: typeof QrQrLookupIDParkEpochRouteRoute
    }
    "/qr/$qrLookupID/park/$epoch/checkout": {
      id: "/qr/$qrLookupID/park/$epoch/checkout"
      path: "/checkout"
      fullPath: "/qr/$qrLookupID/park/$epoch/checkout"
      preLoaderRoute: typeof QrQrLookupIDParkEpochCheckoutRouteImport
      parentRoute: typeof QrQrLookupIDParkEpochRouteRoute
    }
    "/qr/$qrLookupID/park/$epoch/cart": {
      id: "/qr/$qrLookupID/park/$epoch/cart"
      path: "/cart"
      fullPath: "/qr/$qrLookupID/park/$epoch/cart"
      preLoaderRoute: typeof QrQrLookupIDParkEpochCartRouteImport
      parentRoute: typeof QrQrLookupIDParkEpochRouteRoute
    }
    "/qr/$qrLookupID/gated/register/look-up": {
      id: "/qr/$qrLookupID/gated/register/look-up"
      path: "/gated/register/look-up"
      fullPath: "/qr/$qrLookupID/gated/register/look-up"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterLookUpRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/gated/register/contact-info": {
      id: "/qr/$qrLookupID/gated/register/contact-info"
      path: "/gated/register/contact-info"
      fullPath: "/qr/$qrLookupID/gated/register/contact-info"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterContactInfoRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/dev/organisms/reservation-rate-card": {
      id: "/qr/$qrLookupID/dev/organisms/reservation-rate-card"
      path: "/organisms/reservation-rate-card"
      fullPath: "/qr/$qrLookupID/dev/organisms/reservation-rate-card"
      preLoaderRoute: typeof QrQrLookupIDDevOrganismsReservationRateCardRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/organisms/navigation": {
      id: "/qr/$qrLookupID/dev/organisms/navigation"
      path: "/organisms/navigation"
      fullPath: "/qr/$qrLookupID/dev/organisms/navigation"
      preLoaderRoute: typeof QrQrLookupIDDevOrganismsNavigationRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/molecules/range-calendar": {
      id: "/qr/$qrLookupID/dev/molecules/range-calendar"
      path: "/molecules/range-calendar"
      fullPath: "/qr/$qrLookupID/dev/molecules/range-calendar"
      preLoaderRoute: typeof QrQrLookupIDDevMoleculesRangeCalendarRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/molecules/modal": {
      id: "/qr/$qrLookupID/dev/molecules/modal"
      path: "/molecules/modal"
      fullPath: "/qr/$qrLookupID/dev/molecules/modal"
      preLoaderRoute: typeof QrQrLookupIDDevMoleculesModalRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/molecules/forms": {
      id: "/qr/$qrLookupID/dev/molecules/forms"
      path: "/molecules/forms"
      fullPath: "/qr/$qrLookupID/dev/molecules/forms"
      preLoaderRoute: typeof QrQrLookupIDDevMoleculesFormsRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/molecules/date-display": {
      id: "/qr/$qrLookupID/dev/molecules/date-display"
      path: "/molecules/date-display"
      fullPath: "/qr/$qrLookupID/dev/molecules/date-display"
      preLoaderRoute: typeof QrQrLookupIDDevMoleculesDateDisplayRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/atoms/typography": {
      id: "/qr/$qrLookupID/dev/atoms/typography"
      path: "/atoms/typography"
      fullPath: "/qr/$qrLookupID/dev/atoms/typography"
      preLoaderRoute: typeof QrQrLookupIDDevAtomsTypographyRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/atoms/icon": {
      id: "/qr/$qrLookupID/dev/atoms/icon"
      path: "/atoms/icon"
      fullPath: "/qr/$qrLookupID/dev/atoms/icon"
      preLoaderRoute: typeof QrQrLookupIDDevAtomsIconRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/atoms/card": {
      id: "/qr/$qrLookupID/dev/atoms/card"
      path: "/atoms/card"
      fullPath: "/qr/$qrLookupID/dev/atoms/card"
      preLoaderRoute: typeof QrQrLookupIDDevAtomsCardRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/dev/atoms/button": {
      id: "/qr/$qrLookupID/dev/atoms/button"
      path: "/atoms/button"
      fullPath: "/qr/$qrLookupID/dev/atoms/button"
      preLoaderRoute: typeof QrQrLookupIDDevAtomsButtonRouteImport
      parentRoute: typeof QrQrLookupIDDevRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/update-password": {
      id: "/qr/$qrLookupID/_authenticated/account/update-password"
      path: "/update-password"
      fullPath: "/qr/$qrLookupID/account/update-password"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountUpdatePasswordRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/reservations": {
      id: "/qr/$qrLookupID/_authenticated/account/reservations"
      path: "/reservations"
      fullPath: "/qr/$qrLookupID/account/reservations"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountReservationsRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/personal-information": {
      id: "/qr/$qrLookupID/_authenticated/account/personal-information"
      path: "/personal-information"
      fullPath: "/qr/$qrLookupID/account/personal-information"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountPersonalInformationRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/purchase": {
      id: "/qr/$qrLookupID/passes/$epoch/purchase"
      path: "/purchase"
      fullPath: "/qr/$qrLookupID/passes/$epoch/purchase"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochPurchaseRouteRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochRouteRoute
    }
    "/qr/$qrLookupID/gated/register/$sessionID": {
      id: "/qr/$qrLookupID/gated/register/$sessionID"
      path: "/gated/register/$sessionID"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteImport
      parentRoute: typeof QrQrLookupIDRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID"
      path: "/$sessionID"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/vehicles": {
      id: "/qr/$qrLookupID/_authenticated/account/vehicles"
      path: "/vehicles"
      fullPath: "/qr/$qrLookupID/account/vehicles"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/saved-payment-methods": {
      id: "/qr/$qrLookupID/_authenticated/account/saved-payment-methods"
      path: "/saved-payment-methods"
      fullPath: "/qr/$qrLookupID/account/saved-payment-methods"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/passes": {
      id: "/qr/$qrLookupID/_authenticated/account/passes"
      path: "/passes"
      fullPath: "/qr/$qrLookupID/account/passes"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountPassesRouteRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/"
      path: "/calendars"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsIndexRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/purchase/": {
      id: "/qr/$qrLookupID/passes/$epoch/purchase/"
      path: "/"
      fullPath: "/qr/$qrLookupID/passes/$epoch/purchase/"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochPurchaseIndexRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochPurchaseRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/look-up/": {
      id: "/qr/$qrLookupID/gated/$pamID/look-up/"
      path: "/look-up"
      fullPath: "/qr/$qrLookupID/gated/$pamID/look-up/"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDLookUpIndexRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/"
      path: "/"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDIndexRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/vehicles/": {
      id: "/qr/$qrLookupID/_authenticated/account/vehicles/"
      path: "/"
      fullPath: "/qr/$qrLookupID/account/vehicles/"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesIndexRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/": {
      id: "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/"
      path: "/"
      fullPath: "/qr/$qrLookupID/account/saved-payment-methods/"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/passes/": {
      id: "/qr/$qrLookupID/_authenticated/account/passes/"
      path: "/"
      fullPath: "/qr/$qrLookupID/account/passes/"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountPassesIndexRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountPassesRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/memberships/": {
      id: "/qr/$qrLookupID/_authenticated/account/memberships/"
      path: "/memberships"
      fullPath: "/qr/$qrLookupID/account/memberships/"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountMembershipsIndexRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete": {
      id: "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete"
      path: "/payment-complete"
      fullPath: "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochPurchasePaymentCompleteRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochPurchaseRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/purchase/confirmation": {
      id: "/qr/$qrLookupID/passes/$epoch/purchase/confirmation"
      path: "/confirmation"
      fullPath: "/qr/$qrLookupID/passes/$epoch/purchase/confirmation"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochPurchaseConfirmationRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochPurchaseRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/purchase/checkout": {
      id: "/qr/$qrLookupID/passes/$epoch/purchase/checkout"
      path: "/checkout"
      fullPath: "/qr/$qrLookupID/passes/$epoch/purchase/checkout"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochPurchaseCheckoutRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochPurchaseRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/purchase/cart": {
      id: "/qr/$qrLookupID/passes/$epoch/purchase/cart"
      path: "/cart"
      fullPath: "/qr/$qrLookupID/passes/$epoch/purchase/cart"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochPurchaseCartRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochPurchaseRouteRoute
    }
    "/qr/$qrLookupID/gated/register/$sessionID/payment-status": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
      path: "/payment-status"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRouteImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/register/$sessionID/express": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/express"
      path: "/express"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/express"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDExpressRouteImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/register/$sessionID/confirmation": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
      path: "/confirmation"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRouteImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/register/$sessionID/complete": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/complete"
      path: "/complete"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/complete"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDCompleteRouteImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/register/$sessionID/checkout": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/checkout"
      path: "/checkout"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/checkout"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRouteImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/register/$sessionID/cart": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/cart"
      path: "/cart"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/cart"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDCartRouteImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/look-up/challenge": {
      id: "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
      path: "/look-up/challenge"
      fullPath: "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDLookUpChallengeRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
      path: "/payment-status"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
      path: "/checkout"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteRoute
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
      path: "/cart"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDCartRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/vehicles/edit": {
      id: "/qr/$qrLookupID/_authenticated/account/vehicles/edit"
      path: "/edit"
      fullPath: "/qr/$qrLookupID/account/vehicles/edit"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesEditRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/vehicles/create": {
      id: "/qr/$qrLookupID/_authenticated/account/vehicles/create"
      path: "/create"
      fullPath: "/qr/$qrLookupID/account/vehicles/create"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesCreateRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/add": {
      id: "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/add"
      path: "/add"
      fullPath: "/qr/$qrLookupID/account/saved-payment-methods/add"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute
    }
    "/qr/$qrLookupID/_authenticated/account/passes/$passID": {
      id: "/qr/$qrLookupID/_authenticated/account/passes/$passID"
      path: "/$passID"
      fullPath: "/qr/$qrLookupID/account/passes/$passID"
      preLoaderRoute: typeof QrQrLookupIDAuthenticatedAccountPassesPassIDRouteImport
      parentRoute: typeof QrQrLookupIDAuthenticatedAccountPassesRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/redeem/$passID": {
      id: "/qr/$qrLookupID/passes/$epoch/redeem/$passID"
      path: "/redeem/$passID"
      fullPath: "/qr/$qrLookupID/passes/$epoch/redeem/$passID"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDRouteRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/redeem/$passID/": {
      id: "/qr/$qrLookupID/passes/$epoch/redeem/$passID/"
      path: "/"
      fullPath: "/qr/$qrLookupID/passes/$epoch/redeem/$passID/"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDIndexRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete": {
      id: "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete"
      path: "/redemption-complete"
      fullPath: "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDRouteRoute
    }
    "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation": {
      id: "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation"
      path: "/confirmation"
      fullPath: "/qr/$qrLookupID/passes/$epoch/redeem/$passID/confirmation"
      preLoaderRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDConfirmationRouteImport
      parentRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/"
      path: "/calendars/$calendarID/dates/$year/$month"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles"
      path: "/calendars/$calendarID/dates/$year/$month/$day/vehicles"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/vehicles"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation"
      path: "/calendars/$calendarID/dates/$year/$month/$day/confirmation"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/confirmation"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout"
      path: "/calendars/$calendarID/dates/$year/$month/$day/checkout"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/checkout"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates/": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates/"
      path: "/calendars/$calendarID/dates/$year/$month/$day/rates"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates/"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/"
      path: "/calendars/$calendarID/dates/$year/$month/$day/cart"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress"
      path: "/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
    "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired": {
      id: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
      path: "/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
      fullPath: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
      preLoaderRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRouteImport
      parentRoute: typeof QrQrLookupIDReserveEpochRouteRoute
    }
  }
}

interface AuthenticatedAccountPassesRouteRouteChildren {
  AuthenticatedAccountPassesPassIDRoute: typeof AuthenticatedAccountPassesPassIDRoute
  AuthenticatedAccountPassesIndexRoute: typeof AuthenticatedAccountPassesIndexRoute
}

const AuthenticatedAccountPassesRouteRouteChildren: AuthenticatedAccountPassesRouteRouteChildren =
  {
    AuthenticatedAccountPassesPassIDRoute:
      AuthenticatedAccountPassesPassIDRoute,
    AuthenticatedAccountPassesIndexRoute: AuthenticatedAccountPassesIndexRoute,
  }

const AuthenticatedAccountPassesRouteRouteWithChildren =
  AuthenticatedAccountPassesRouteRoute._addFileChildren(
    AuthenticatedAccountPassesRouteRouteChildren,
  )

interface AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren {
  AuthenticatedAccountSavedPaymentMethodsAddRoute: typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  AuthenticatedAccountSavedPaymentMethodsIndexRoute: typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
}

const AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren: AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren =
  {
    AuthenticatedAccountSavedPaymentMethodsAddRoute:
      AuthenticatedAccountSavedPaymentMethodsAddRoute,
    AuthenticatedAccountSavedPaymentMethodsIndexRoute:
      AuthenticatedAccountSavedPaymentMethodsIndexRoute,
  }

const AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren =
  AuthenticatedAccountSavedPaymentMethodsRouteRoute._addFileChildren(
    AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren,
  )

interface AuthenticatedAccountVehiclesRouteRouteChildren {
  AuthenticatedAccountVehiclesCreateRoute: typeof AuthenticatedAccountVehiclesCreateRoute
  AuthenticatedAccountVehiclesEditRoute: typeof AuthenticatedAccountVehiclesEditRoute
  AuthenticatedAccountVehiclesIndexRoute: typeof AuthenticatedAccountVehiclesIndexRoute
}

const AuthenticatedAccountVehiclesRouteRouteChildren: AuthenticatedAccountVehiclesRouteRouteChildren =
  {
    AuthenticatedAccountVehiclesCreateRoute:
      AuthenticatedAccountVehiclesCreateRoute,
    AuthenticatedAccountVehiclesEditRoute:
      AuthenticatedAccountVehiclesEditRoute,
    AuthenticatedAccountVehiclesIndexRoute:
      AuthenticatedAccountVehiclesIndexRoute,
  }

const AuthenticatedAccountVehiclesRouteRouteWithChildren =
  AuthenticatedAccountVehiclesRouteRoute._addFileChildren(
    AuthenticatedAccountVehiclesRouteRouteChildren,
  )

interface AuthenticatedAccountRouteRouteChildren {
  AuthenticatedAccountPassesRouteRoute: typeof AuthenticatedAccountPassesRouteRouteWithChildren
  AuthenticatedAccountSavedPaymentMethodsRouteRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  AuthenticatedAccountVehiclesRouteRoute: typeof AuthenticatedAccountVehiclesRouteRouteWithChildren
  AuthenticatedAccountPersonalInformationRoute: typeof AuthenticatedAccountPersonalInformationRoute
  AuthenticatedAccountReservationsRoute: typeof AuthenticatedAccountReservationsRoute
  AuthenticatedAccountUpdatePasswordRoute: typeof AuthenticatedAccountUpdatePasswordRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
  AuthenticatedAccountMembershipsIndexRoute: typeof AuthenticatedAccountMembershipsIndexRoute
}

const AuthenticatedAccountRouteRouteChildren: AuthenticatedAccountRouteRouteChildren =
  {
    AuthenticatedAccountPassesRouteRoute:
      AuthenticatedAccountPassesRouteRouteWithChildren,
    AuthenticatedAccountSavedPaymentMethodsRouteRoute:
      AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren,
    AuthenticatedAccountVehiclesRouteRoute:
      AuthenticatedAccountVehiclesRouteRouteWithChildren,
    AuthenticatedAccountPersonalInformationRoute:
      AuthenticatedAccountPersonalInformationRoute,
    AuthenticatedAccountReservationsRoute:
      AuthenticatedAccountReservationsRoute,
    AuthenticatedAccountUpdatePasswordRoute:
      AuthenticatedAccountUpdatePasswordRoute,
    AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
    AuthenticatedAccountMembershipsIndexRoute:
      AuthenticatedAccountMembershipsIndexRoute,
  }

const AuthenticatedAccountRouteRouteWithChildren =
  AuthenticatedAccountRouteRoute._addFileChildren(
    AuthenticatedAccountRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAccountRouteRoute: typeof AuthenticatedAccountRouteRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRouteRoute: AuthenticatedAccountRouteRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthCreateAccountRoute: typeof AuthCreateAccountRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthSignInSetNewPasswordRoute: typeof AuthSignInSetNewPasswordRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCreateAccountRoute: AuthCreateAccountRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthSignInSetNewPasswordRoute: AuthSignInSetNewPasswordRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface QrQrLookupIDAuthenticatedAccountPassesRouteRouteChildren {
  QrQrLookupIDAuthenticatedAccountPassesPassIDRoute: typeof QrQrLookupIDAuthenticatedAccountPassesPassIDRoute
  QrQrLookupIDAuthenticatedAccountPassesIndexRoute: typeof QrQrLookupIDAuthenticatedAccountPassesIndexRoute
}

const QrQrLookupIDAuthenticatedAccountPassesRouteRouteChildren: QrQrLookupIDAuthenticatedAccountPassesRouteRouteChildren =
  {
    QrQrLookupIDAuthenticatedAccountPassesPassIDRoute:
      QrQrLookupIDAuthenticatedAccountPassesPassIDRoute,
    QrQrLookupIDAuthenticatedAccountPassesIndexRoute:
      QrQrLookupIDAuthenticatedAccountPassesIndexRoute,
  }

const QrQrLookupIDAuthenticatedAccountPassesRouteRouteWithChildren =
  QrQrLookupIDAuthenticatedAccountPassesRouteRoute._addFileChildren(
    QrQrLookupIDAuthenticatedAccountPassesRouteRouteChildren,
  )

interface QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteChildren {
  QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute
  QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute
}

const QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteChildren: QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteChildren =
  {
    QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute:
      QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsAddRoute,
    QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute:
      QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsIndexRoute,
  }

const QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren =
  QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute._addFileChildren(
    QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteChildren,
  )

interface QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteChildren {
  QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute
  QrQrLookupIDAuthenticatedAccountVehiclesEditRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesEditRoute
  QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute
}

const QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteChildren: QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteChildren =
  {
    QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute:
      QrQrLookupIDAuthenticatedAccountVehiclesCreateRoute,
    QrQrLookupIDAuthenticatedAccountVehiclesEditRoute:
      QrQrLookupIDAuthenticatedAccountVehiclesEditRoute,
    QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute:
      QrQrLookupIDAuthenticatedAccountVehiclesIndexRoute,
  }

const QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteWithChildren =
  QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute._addFileChildren(
    QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteChildren,
  )

interface QrQrLookupIDAuthenticatedAccountRouteRouteChildren {
  QrQrLookupIDAuthenticatedAccountPassesRouteRoute: typeof QrQrLookupIDAuthenticatedAccountPassesRouteRouteWithChildren
  QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute: typeof QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute: typeof QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteWithChildren
  QrQrLookupIDAuthenticatedAccountPersonalInformationRoute: typeof QrQrLookupIDAuthenticatedAccountPersonalInformationRoute
  QrQrLookupIDAuthenticatedAccountReservationsRoute: typeof QrQrLookupIDAuthenticatedAccountReservationsRoute
  QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute: typeof QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute
  QrQrLookupIDAuthenticatedAccountIndexRoute: typeof QrQrLookupIDAuthenticatedAccountIndexRoute
  QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute: typeof QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute
}

const QrQrLookupIDAuthenticatedAccountRouteRouteChildren: QrQrLookupIDAuthenticatedAccountRouteRouteChildren =
  {
    QrQrLookupIDAuthenticatedAccountPassesRouteRoute:
      QrQrLookupIDAuthenticatedAccountPassesRouteRouteWithChildren,
    QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRoute:
      QrQrLookupIDAuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren,
    QrQrLookupIDAuthenticatedAccountVehiclesRouteRoute:
      QrQrLookupIDAuthenticatedAccountVehiclesRouteRouteWithChildren,
    QrQrLookupIDAuthenticatedAccountPersonalInformationRoute:
      QrQrLookupIDAuthenticatedAccountPersonalInformationRoute,
    QrQrLookupIDAuthenticatedAccountReservationsRoute:
      QrQrLookupIDAuthenticatedAccountReservationsRoute,
    QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute:
      QrQrLookupIDAuthenticatedAccountUpdatePasswordRoute,
    QrQrLookupIDAuthenticatedAccountIndexRoute:
      QrQrLookupIDAuthenticatedAccountIndexRoute,
    QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute:
      QrQrLookupIDAuthenticatedAccountMembershipsIndexRoute,
  }

const QrQrLookupIDAuthenticatedAccountRouteRouteWithChildren =
  QrQrLookupIDAuthenticatedAccountRouteRoute._addFileChildren(
    QrQrLookupIDAuthenticatedAccountRouteRouteChildren,
  )

interface QrQrLookupIDAuthenticatedRouteRouteChildren {
  QrQrLookupIDAuthenticatedAccountRouteRoute: typeof QrQrLookupIDAuthenticatedAccountRouteRouteWithChildren
}

const QrQrLookupIDAuthenticatedRouteRouteChildren: QrQrLookupIDAuthenticatedRouteRouteChildren =
  {
    QrQrLookupIDAuthenticatedAccountRouteRoute:
      QrQrLookupIDAuthenticatedAccountRouteRouteWithChildren,
  }

const QrQrLookupIDAuthenticatedRouteRouteWithChildren =
  QrQrLookupIDAuthenticatedRouteRoute._addFileChildren(
    QrQrLookupIDAuthenticatedRouteRouteChildren,
  )

interface QrQrLookupIDDevRouteRouteChildren {
  QrQrLookupIDDevGutCheckRoute: typeof QrQrLookupIDDevGutCheckRoute
  QrQrLookupIDDevIndexRoute: typeof QrQrLookupIDDevIndexRoute
  QrQrLookupIDDevAtomsButtonRoute: typeof QrQrLookupIDDevAtomsButtonRoute
  QrQrLookupIDDevAtomsCardRoute: typeof QrQrLookupIDDevAtomsCardRoute
  QrQrLookupIDDevAtomsIconRoute: typeof QrQrLookupIDDevAtomsIconRoute
  QrQrLookupIDDevAtomsTypographyRoute: typeof QrQrLookupIDDevAtomsTypographyRoute
  QrQrLookupIDDevMoleculesDateDisplayRoute: typeof QrQrLookupIDDevMoleculesDateDisplayRoute
  QrQrLookupIDDevMoleculesFormsRoute: typeof QrQrLookupIDDevMoleculesFormsRoute
  QrQrLookupIDDevMoleculesModalRoute: typeof QrQrLookupIDDevMoleculesModalRoute
  QrQrLookupIDDevMoleculesRangeCalendarRoute: typeof QrQrLookupIDDevMoleculesRangeCalendarRoute
  QrQrLookupIDDevOrganismsNavigationRoute: typeof QrQrLookupIDDevOrganismsNavigationRoute
  QrQrLookupIDDevOrganismsReservationRateCardRoute: typeof QrQrLookupIDDevOrganismsReservationRateCardRoute
}

const QrQrLookupIDDevRouteRouteChildren: QrQrLookupIDDevRouteRouteChildren = {
  QrQrLookupIDDevGutCheckRoute: QrQrLookupIDDevGutCheckRoute,
  QrQrLookupIDDevIndexRoute: QrQrLookupIDDevIndexRoute,
  QrQrLookupIDDevAtomsButtonRoute: QrQrLookupIDDevAtomsButtonRoute,
  QrQrLookupIDDevAtomsCardRoute: QrQrLookupIDDevAtomsCardRoute,
  QrQrLookupIDDevAtomsIconRoute: QrQrLookupIDDevAtomsIconRoute,
  QrQrLookupIDDevAtomsTypographyRoute: QrQrLookupIDDevAtomsTypographyRoute,
  QrQrLookupIDDevMoleculesDateDisplayRoute:
    QrQrLookupIDDevMoleculesDateDisplayRoute,
  QrQrLookupIDDevMoleculesFormsRoute: QrQrLookupIDDevMoleculesFormsRoute,
  QrQrLookupIDDevMoleculesModalRoute: QrQrLookupIDDevMoleculesModalRoute,
  QrQrLookupIDDevMoleculesRangeCalendarRoute:
    QrQrLookupIDDevMoleculesRangeCalendarRoute,
  QrQrLookupIDDevOrganismsNavigationRoute:
    QrQrLookupIDDevOrganismsNavigationRoute,
  QrQrLookupIDDevOrganismsReservationRateCardRoute:
    QrQrLookupIDDevOrganismsReservationRateCardRoute,
}

const QrQrLookupIDDevRouteRouteWithChildren =
  QrQrLookupIDDevRouteRoute._addFileChildren(QrQrLookupIDDevRouteRouteChildren)

interface QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren {
  QrQrLookupIDGatedPamIDSessionIDCartRoute: typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  QrQrLookupIDGatedPamIDSessionIDCheckoutRoute: typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute: typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  QrQrLookupIDGatedPamIDSessionIDIndexRoute: typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
}

const QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren: QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren =
  {
    QrQrLookupIDGatedPamIDSessionIDCartRoute:
      QrQrLookupIDGatedPamIDSessionIDCartRoute,
    QrQrLookupIDGatedPamIDSessionIDCheckoutRoute:
      QrQrLookupIDGatedPamIDSessionIDCheckoutRoute,
    QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute:
      QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute,
    QrQrLookupIDGatedPamIDSessionIDIndexRoute:
      QrQrLookupIDGatedPamIDSessionIDIndexRoute,
  }

const QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren =
  QrQrLookupIDGatedPamIDSessionIDRouteRoute._addFileChildren(
    QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren,
  )

interface QrQrLookupIDGatedPamIDRouteRouteChildren {
  QrQrLookupIDGatedPamIDSessionIDRouteRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren
  QrQrLookupIDGatedPamIDIndexRoute: typeof QrQrLookupIDGatedPamIDIndexRoute
  QrQrLookupIDGatedPamIDLookUpChallengeRoute: typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  QrQrLookupIDGatedPamIDLookUpIndexRoute: typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
}

const QrQrLookupIDGatedPamIDRouteRouteChildren: QrQrLookupIDGatedPamIDRouteRouteChildren =
  {
    QrQrLookupIDGatedPamIDSessionIDRouteRoute:
      QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren,
    QrQrLookupIDGatedPamIDIndexRoute: QrQrLookupIDGatedPamIDIndexRoute,
    QrQrLookupIDGatedPamIDLookUpChallengeRoute:
      QrQrLookupIDGatedPamIDLookUpChallengeRoute,
    QrQrLookupIDGatedPamIDLookUpIndexRoute:
      QrQrLookupIDGatedPamIDLookUpIndexRoute,
  }

const QrQrLookupIDGatedPamIDRouteRouteWithChildren =
  QrQrLookupIDGatedPamIDRouteRoute._addFileChildren(
    QrQrLookupIDGatedPamIDRouteRouteChildren,
  )

interface QrQrLookupIDParkEpochRouteRouteChildren {
  QrQrLookupIDParkEpochCartRoute: typeof QrQrLookupIDParkEpochCartRoute
  QrQrLookupIDParkEpochCheckoutRoute: typeof QrQrLookupIDParkEpochCheckoutRoute
  QrQrLookupIDParkEpochConfirmationRoute: typeof QrQrLookupIDParkEpochConfirmationRoute
  QrQrLookupIDParkEpochPaymentCompleteRoute: typeof QrQrLookupIDParkEpochPaymentCompleteRoute
  QrQrLookupIDParkEpochRatesRoute: typeof QrQrLookupIDParkEpochRatesRoute
  QrQrLookupIDParkEpochRegisterRoute: typeof QrQrLookupIDParkEpochRegisterRoute
}

const QrQrLookupIDParkEpochRouteRouteChildren: QrQrLookupIDParkEpochRouteRouteChildren =
  {
    QrQrLookupIDParkEpochCartRoute: QrQrLookupIDParkEpochCartRoute,
    QrQrLookupIDParkEpochCheckoutRoute: QrQrLookupIDParkEpochCheckoutRoute,
    QrQrLookupIDParkEpochConfirmationRoute:
      QrQrLookupIDParkEpochConfirmationRoute,
    QrQrLookupIDParkEpochPaymentCompleteRoute:
      QrQrLookupIDParkEpochPaymentCompleteRoute,
    QrQrLookupIDParkEpochRatesRoute: QrQrLookupIDParkEpochRatesRoute,
    QrQrLookupIDParkEpochRegisterRoute: QrQrLookupIDParkEpochRegisterRoute,
  }

const QrQrLookupIDParkEpochRouteRouteWithChildren =
  QrQrLookupIDParkEpochRouteRoute._addFileChildren(
    QrQrLookupIDParkEpochRouteRouteChildren,
  )

interface QrQrLookupIDPassesEpochPurchaseRouteRouteChildren {
  QrQrLookupIDPassesEpochPurchaseCartRoute: typeof QrQrLookupIDPassesEpochPurchaseCartRoute
  QrQrLookupIDPassesEpochPurchaseCheckoutRoute: typeof QrQrLookupIDPassesEpochPurchaseCheckoutRoute
  QrQrLookupIDPassesEpochPurchaseConfirmationRoute: typeof QrQrLookupIDPassesEpochPurchaseConfirmationRoute
  QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute: typeof QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute
  QrQrLookupIDPassesEpochPurchaseIndexRoute: typeof QrQrLookupIDPassesEpochPurchaseIndexRoute
}

const QrQrLookupIDPassesEpochPurchaseRouteRouteChildren: QrQrLookupIDPassesEpochPurchaseRouteRouteChildren =
  {
    QrQrLookupIDPassesEpochPurchaseCartRoute:
      QrQrLookupIDPassesEpochPurchaseCartRoute,
    QrQrLookupIDPassesEpochPurchaseCheckoutRoute:
      QrQrLookupIDPassesEpochPurchaseCheckoutRoute,
    QrQrLookupIDPassesEpochPurchaseConfirmationRoute:
      QrQrLookupIDPassesEpochPurchaseConfirmationRoute,
    QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute:
      QrQrLookupIDPassesEpochPurchasePaymentCompleteRoute,
    QrQrLookupIDPassesEpochPurchaseIndexRoute:
      QrQrLookupIDPassesEpochPurchaseIndexRoute,
  }

const QrQrLookupIDPassesEpochPurchaseRouteRouteWithChildren =
  QrQrLookupIDPassesEpochPurchaseRouteRoute._addFileChildren(
    QrQrLookupIDPassesEpochPurchaseRouteRouteChildren,
  )

interface QrQrLookupIDPassesEpochRedeemPassIDRouteRouteChildren {
  QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute
  QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute
  QrQrLookupIDPassesEpochRedeemPassIDIndexRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDIndexRoute
}

const QrQrLookupIDPassesEpochRedeemPassIDRouteRouteChildren: QrQrLookupIDPassesEpochRedeemPassIDRouteRouteChildren =
  {
    QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute:
      QrQrLookupIDPassesEpochRedeemPassIDConfirmationRoute,
    QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute:
      QrQrLookupIDPassesEpochRedeemPassIDRedemptionCompleteRoute,
    QrQrLookupIDPassesEpochRedeemPassIDIndexRoute:
      QrQrLookupIDPassesEpochRedeemPassIDIndexRoute,
  }

const QrQrLookupIDPassesEpochRedeemPassIDRouteRouteWithChildren =
  QrQrLookupIDPassesEpochRedeemPassIDRouteRoute._addFileChildren(
    QrQrLookupIDPassesEpochRedeemPassIDRouteRouteChildren,
  )

interface QrQrLookupIDPassesEpochRouteRouteChildren {
  QrQrLookupIDPassesEpochPurchaseRouteRoute: typeof QrQrLookupIDPassesEpochPurchaseRouteRouteWithChildren
  QrQrLookupIDPassesEpochRedeemPassIDRouteRoute: typeof QrQrLookupIDPassesEpochRedeemPassIDRouteRouteWithChildren
}

const QrQrLookupIDPassesEpochRouteRouteChildren: QrQrLookupIDPassesEpochRouteRouteChildren =
  {
    QrQrLookupIDPassesEpochPurchaseRouteRoute:
      QrQrLookupIDPassesEpochPurchaseRouteRouteWithChildren,
    QrQrLookupIDPassesEpochRedeemPassIDRouteRoute:
      QrQrLookupIDPassesEpochRedeemPassIDRouteRouteWithChildren,
  }

const QrQrLookupIDPassesEpochRouteRouteWithChildren =
  QrQrLookupIDPassesEpochRouteRoute._addFileChildren(
    QrQrLookupIDPassesEpochRouteRouteChildren,
  )

interface QrQrLookupIDReserveEpochRouteRouteChildren {
  QrQrLookupIDReserveEpochPaymentCompleteRoute: typeof QrQrLookupIDReserveEpochPaymentCompleteRoute
  QrQrLookupIDReserveEpochCalendarsIndexRoute: typeof QrQrLookupIDReserveEpochCalendarsIndexRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute
  QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute: typeof QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute
}

const QrQrLookupIDReserveEpochRouteRouteChildren: QrQrLookupIDReserveEpochRouteRouteChildren =
  {
    QrQrLookupIDReserveEpochPaymentCompleteRoute:
      QrQrLookupIDReserveEpochPaymentCompleteRoute,
    QrQrLookupIDReserveEpochCalendarsIndexRoute:
      QrQrLookupIDReserveEpochCalendarsIndexRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthIndexRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCheckoutRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayConfirmationRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayVehiclesRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartExpiredRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartInProgressRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayCartIndexRoute,
    QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute:
      QrQrLookupIDReserveEpochCalendarsCalendarIDDatesYearMonthDayRatesIndexRoute,
  }

const QrQrLookupIDReserveEpochRouteRouteWithChildren =
  QrQrLookupIDReserveEpochRouteRoute._addFileChildren(
    QrQrLookupIDReserveEpochRouteRouteChildren,
  )

interface QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren {
  QrQrLookupIDGatedRegisterSessionIDCartRoute: typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  QrQrLookupIDGatedRegisterSessionIDCheckoutRoute: typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  QrQrLookupIDGatedRegisterSessionIDCompleteRoute: typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  QrQrLookupIDGatedRegisterSessionIDConfirmationRoute: typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  QrQrLookupIDGatedRegisterSessionIDExpressRoute: typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute: typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
}

const QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren: QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren =
  {
    QrQrLookupIDGatedRegisterSessionIDCartRoute:
      QrQrLookupIDGatedRegisterSessionIDCartRoute,
    QrQrLookupIDGatedRegisterSessionIDCheckoutRoute:
      QrQrLookupIDGatedRegisterSessionIDCheckoutRoute,
    QrQrLookupIDGatedRegisterSessionIDCompleteRoute:
      QrQrLookupIDGatedRegisterSessionIDCompleteRoute,
    QrQrLookupIDGatedRegisterSessionIDConfirmationRoute:
      QrQrLookupIDGatedRegisterSessionIDConfirmationRoute,
    QrQrLookupIDGatedRegisterSessionIDExpressRoute:
      QrQrLookupIDGatedRegisterSessionIDExpressRoute,
    QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute:
      QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute,
  }

const QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren =
  QrQrLookupIDGatedRegisterSessionIDRouteRoute._addFileChildren(
    QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren,
  )

interface QrQrLookupIDRouteRouteChildren {
  QrQrLookupIDAuthenticatedRouteRoute: typeof QrQrLookupIDAuthenticatedRouteRouteWithChildren
  QrQrLookupIDDevRouteRoute: typeof QrQrLookupIDDevRouteRouteWithChildren
  QrQrLookupIDHelpRoute: typeof QrQrLookupIDHelpRoute
  QrQrLookupIDPoliciesRoute: typeof QrQrLookupIDPoliciesRoute
  QrQrLookupIDPrivacyPolicyRoute: typeof QrQrLookupIDPrivacyPolicyRoute
  QrQrLookupIDTermsOfUseRoute: typeof QrQrLookupIDTermsOfUseRoute
  QrQrLookupIDIndexRoute: typeof QrQrLookupIDIndexRoute
  QrQrLookupIDGatedPamIDRouteRoute: typeof QrQrLookupIDGatedPamIDRouteRouteWithChildren
  QrQrLookupIDParkEpochRouteRoute: typeof QrQrLookupIDParkEpochRouteRouteWithChildren
  QrQrLookupIDPassesEpochRouteRoute: typeof QrQrLookupIDPassesEpochRouteRouteWithChildren
  QrQrLookupIDReserveEpochRouteRoute: typeof QrQrLookupIDReserveEpochRouteRouteWithChildren
  QrQrLookupIDReceiptReceiptIDRoute: typeof QrQrLookupIDReceiptReceiptIDRoute
  QrQrLookupIDWelcomeIndexRoute: typeof QrQrLookupIDWelcomeIndexRoute
  QrQrLookupIDGatedRegisterSessionIDRouteRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  QrQrLookupIDGatedRegisterContactInfoRoute: typeof QrQrLookupIDGatedRegisterContactInfoRoute
  QrQrLookupIDGatedRegisterLookUpRoute: typeof QrQrLookupIDGatedRegisterLookUpRoute
}

const QrQrLookupIDRouteRouteChildren: QrQrLookupIDRouteRouteChildren = {
  QrQrLookupIDAuthenticatedRouteRoute:
    QrQrLookupIDAuthenticatedRouteRouteWithChildren,
  QrQrLookupIDDevRouteRoute: QrQrLookupIDDevRouteRouteWithChildren,
  QrQrLookupIDHelpRoute: QrQrLookupIDHelpRoute,
  QrQrLookupIDPoliciesRoute: QrQrLookupIDPoliciesRoute,
  QrQrLookupIDPrivacyPolicyRoute: QrQrLookupIDPrivacyPolicyRoute,
  QrQrLookupIDTermsOfUseRoute: QrQrLookupIDTermsOfUseRoute,
  QrQrLookupIDIndexRoute: QrQrLookupIDIndexRoute,
  QrQrLookupIDGatedPamIDRouteRoute:
    QrQrLookupIDGatedPamIDRouteRouteWithChildren,
  QrQrLookupIDParkEpochRouteRoute: QrQrLookupIDParkEpochRouteRouteWithChildren,
  QrQrLookupIDPassesEpochRouteRoute:
    QrQrLookupIDPassesEpochRouteRouteWithChildren,
  QrQrLookupIDReserveEpochRouteRoute:
    QrQrLookupIDReserveEpochRouteRouteWithChildren,
  QrQrLookupIDReceiptReceiptIDRoute: QrQrLookupIDReceiptReceiptIDRoute,
  QrQrLookupIDWelcomeIndexRoute: QrQrLookupIDWelcomeIndexRoute,
  QrQrLookupIDGatedRegisterSessionIDRouteRoute:
    QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren,
  QrQrLookupIDGatedRegisterContactInfoRoute:
    QrQrLookupIDGatedRegisterContactInfoRoute,
  QrQrLookupIDGatedRegisterLookUpRoute: QrQrLookupIDGatedRegisterLookUpRoute,
}

const QrQrLookupIDRouteRouteWithChildren =
  QrQrLookupIDRouteRoute._addFileChildren(QrQrLookupIDRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ConfirmationRoute: ConfirmationRoute,
  HelpRoute: HelpRoute,
  PoliciesRoute: PoliciesRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfUseRoute: TermsOfUseRoute,
  WelcomeRoute: WelcomeRoute,
  QrQrLookupIDRouteRoute: QrQrLookupIDRouteRouteWithChildren,
  ReceiptReceiptIDRoute: ReceiptReceiptIDRoute,
  ReceiptIndexRoute: ReceiptIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
